import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Json: any;
};

export type Account = {
  __typename?: 'Account';
  actionKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationCollaboration?: Maybe<Scalars['Boolean']>;
  integrationHRIS?: Maybe<Scalars['Boolean']>;
  isStripeCustomer: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  selectedPlanType?: Maybe<Scalars['String']>;
  slackWorkspaceId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  subscriptions: Array<Subscription>;
  users: Array<User>;
};

export type AccountInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  user: UserInput;
};

export type AccountIntegration = {
  __typename?: 'AccountIntegration';
  accessToken: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  atsName: Scalars['String'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  integrationId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  locality?: Maybe<Scalars['String']>;
};

export type AnsweredChoice = {
  __typename?: 'AnsweredChoice';
  choice: Choice;
  users: Array<Maybe<User>>;
};

export type AnsweredText = {
  __typename?: 'AnsweredText';
  choice: Choice;
  users: Array<Maybe<UserWithAnswer>>;
};

export type BillingAction = {
  __typename?: 'BillingAction';
  cardLast4digit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Board = {
  __typename?: 'Board';
  accountId: Scalars['String'];
  boardMember: Array<BoardMember>;
  boardViewer: Array<BoardViewer>;
  editor?: Maybe<Scalars['String']>;
  editorUser?: Maybe<User>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type BoardDetails = {
  __typename?: 'BoardDetails';
  boardMember: Array<BoardMemberData>;
  editorUser?: Maybe<User>;
  name: Scalars['String'];
};

export type BoardMember = {
  __typename?: 'BoardMember';
  board: Board;
  boardId: Scalars['String'];
  id: Scalars['ID'];
  user: User;
  userId: Scalars['String'];
};

export type BoardMemberData = {
  __typename?: 'BoardMemberData';
  user: User;
};

export type BoardReportViewer = {
  __typename?: 'BoardReportViewer';
  board?: Maybe<BoardDetails>;
  sectionFeatures: Array<Maybe<SectionFeature>>;
  sectionHeader: Scalars['String'];
};

export type BoardRosterUser = {
  __typename?: 'BoardRosterUser';
  boardId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type BoardRosters = {
  __typename?: 'BoardRosters';
  board?: Maybe<BoardDetails>;
  features: Array<Maybe<Feature>>;
  members: Array<Maybe<BoardRosterUser>>;
};

export type BoardViewer = {
  __typename?: 'BoardViewer';
  boardId: Scalars['String'];
  id: Scalars['ID'];
  userId: Scalars['String'];
};

export type BoardViewerFeature = {
  __typename?: 'BoardViewerFeature';
  answeredChoices?: Maybe<Array<Maybe<AnsweredChoice>>>;
  answeredTexts?: Maybe<Array<Maybe<UserWithAnswer>>>;
  feature: Feature;
  insights?: Maybe<Array<Maybe<Insight>>>;
};

export type ChangePlanInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  estimatedTeamSize?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['String']>;
  planType?: InputMaybe<Scalars['String']>;
};

export type ChangePlanResponse = {
  __typename?: 'ChangePlanResponse';
  message: Scalars['String'];
};

export type ChangeSubscriptionBillingEmail = {
  email?: InputMaybe<Scalars['String']>;
};

export type ChangeSubscriptionBillingEmailResponse = {
  __typename?: 'ChangeSubscriptionBillingEmailResponse';
  message: Scalars['String'];
};

export type ChangeSubscriptionPaymentMethod = {
  striptPaymentMethodId?: InputMaybe<Scalars['String']>;
};

export type ChangeSubscriptionPaymentMethodResponse = {
  __typename?: 'ChangeSubscriptionPaymentMethodResponse';
  message: Scalars['String'];
};

export type Choice = {
  __typename?: 'Choice';
  createdAt: Scalars['DateTime'];
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  feature: Feature;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  placeholder?: Maybe<Placeholder>;
  placeholderText?: Maybe<Scalars['String']>;
  placeholderValue?: Maybe<Scalars['Json']>;
  shortChoiceLabel?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ChoiceCreateInput = {
  insight?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  placeholderText?: InputMaybe<Scalars['String']>;
  placeholderValue?: InputMaybe<Scalars['Json']>;
  shortChoiceLabel?: InputMaybe<Scalars['Json']>;
  text: Scalars['String'];
};

export type ChoiceUpdateInput = {
  id?: InputMaybe<Scalars['String']>;
  insight?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  placeholderText?: InputMaybe<Scalars['String']>;
  placeholderValue?: InputMaybe<Scalars['Json']>;
  shortChoiceLabel?: InputMaybe<Scalars['Json']>;
  text: Scalars['String'];
};

export type ContactLluna = {
  __typename?: 'ContactLluna';
  additionalInfo?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  estimatedTeamSize: Scalars['Int'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type CreateAccountIntegrationInput = {
  accessToken: Scalars['String'];
  accountId: Scalars['String'];
  atsName: Scalars['String'];
  createdBy?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['String'];
  integrationProviderDetails?: InputMaybe<Scalars['Json']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['String'];
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type CreateBoardInput = {
  boardMember?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  boardViewer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  editor: Scalars['String'];
  name: Scalars['String'];
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type CreateBoardMemberInput = {
  boardId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateBoardViewerInput = {
  boardId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateContactLlunaInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  estimatedTeamSize?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateNotificationReaderInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  notificationId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  readerId: Scalars['String'];
  state: NotificationState;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type CreateNotificationReaderRes = {
  __typename?: 'CreateNotificationReaderRes';
  count: Scalars['Int'];
};

export type CreatePlainUserInput = {
  accountId: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  customSharableString?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  industry?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  onFreePlan?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  readMe?: InputMaybe<Scalars['String']>;
  roles: Array<UserRole>;
  surname: Scalars['String'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type CreateReadmeInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  quickStartComplete?: InputMaybe<Scalars['Boolean']>;
  responses?: InputMaybe<Scalars['Json']>;
};

export type CreateSubscriptionInput = {
  /** Selected Coupon Id */
  couponId?: InputMaybe<Scalars['String']>;
  /** Stripe Payment Method ID returned by successful SetupPaymentIntent */
  paymentMethodId: Scalars['String'];
  /** ID of selected planPrice item */
  planPriceId: Scalars['String'];
  /** Selected plan type */
  planType?: InputMaybe<Scalars['String']>;
  /** Number of seats */
  quantity: Scalars['Int'];
};

export type CreateUpdateBoardReponse = {
  __typename?: 'CreateUpdateBoardReponse';
  boardMember: Scalars['String'];
  boardViewer: Scalars['String'];
  createdby: Scalars['String'];
  editor: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  updatedby: Scalars['String'];
};

export type CreateUserInput = {
  additionalPermissions: Array<UserAdditionalPermissions>;
  companyName?: InputMaybe<Scalars['String']>;
  customSharableString?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId?: InputMaybe<Scalars['String']>;
  filterScope?: InputMaybe<Scalars['Json']>;
  finchUserId?: InputMaybe<Scalars['String']>;
  function?: InputMaybe<Scalars['String']>;
  hireDate?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  managerDetails?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  objects?: InputMaybe<Scalars['String']>;
  officeLocation?: InputMaybe<Scalars['String']>;
  onFreePlan?: InputMaybe<Scalars['String']>;
  paidTimeOff?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  possessives?: InputMaybe<Scalars['String']>;
  readMe?: InputMaybe<Scalars['String']>;
  roles: Array<UserRole>;
  subjects?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type CustomerPaymentMethodsResponse = {
  __typename?: 'CustomerPaymentMethodsResponse';
  expireYear?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  isDefaultPaymentMethod?: Maybe<Scalars['Boolean']>;
  last4Digits: Scalars['String'];
  name: Scalars['String'];
  paymentMethodId: Scalars['String'];
  type: Scalars['String'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  sharedReadMeViewCount?: Maybe<Scalars['Int']>;
};

export type DeleteBoardInput = {
  boardId: Scalars['String'];
};

export type Dimension = DimensionI & {
  __typename?: 'Dimension';
  features: Array<Feature>;
  id: Scalars['ID'];
  meta?: Maybe<Scalars['Json']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type DimensionI = {
  features: Array<Feature>;
  id: Scalars['ID'];
  meta?: Maybe<Scalars['Json']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type DimensionInput = {
  backgroundColor: Scalars['String'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  textColor: Scalars['String'];
};

export type DimensionUpdateInput = {
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  textColor: Scalars['String'];
};

export type EmailPopData = {
  __typename?: 'EmailPopData';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  popUrl?: Maybe<Scalars['String']>;
  possessive?: Maybe<Scalars['String']>;
  quickStartComplete: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
};

export type FwDimension = DimensionI & {
  __typename?: 'FWDimension';
  features: Array<Feature>;
  id: Scalars['ID'];
  meta?: Maybe<Scalars['Json']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
};

export type Feature = {
  __typename?: 'Feature';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  additionalComments?: Maybe<Scalars['String']>;
  choices: Array<Choice>;
  definitionAnswer?: Maybe<Scalars['String']>;
  definitionQuestion?: Maybe<Scalars['String']>;
  definitionTF?: Maybe<Scalars['Boolean']>;
  dimension: Dimension;
  followUps: Array<Choice>;
  hasReport?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isFollowUp: Scalars['Boolean'];
  key?: Maybe<Scalars['String']>;
  learnMoreLabel?: Maybe<Scalars['String']>;
  learnMoreTF?: Maybe<Scalars['Boolean']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['Json']>;
  placeholder?: Maybe<Scalars['String']>;
  purposeAnswer?: Maybe<Scalars['String']>;
  purposeQuestion?: Maybe<Scalars['String']>;
  purposeTF?: Maybe<Scalars['Boolean']>;
  quickStart?: Maybe<Scalars['Boolean']>;
  reportKey?: Maybe<Scalars['String']>;
  scatteredInsight?: Maybe<Scalars['String']>;
  shortLabel?: Maybe<Scalars['String']>;
  showAsTagTF?: Maybe<Scalars['Boolean']>;
  text: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: FeatureType;
};

export type FeatureCreateInput = {
  accountId?: InputMaybe<Scalars['String']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  choices?: InputMaybe<Array<ChoiceCreateInput>>;
  definitionAnswer?: InputMaybe<Scalars['String']>;
  definitionQuestion?: InputMaybe<Scalars['String']>;
  definitionTF?: InputMaybe<Scalars['Boolean']>;
  dimensionId: Scalars['String'];
  hasReport?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  learnMoreLabel?: InputMaybe<Scalars['String']>;
  learnMoreTF?: InputMaybe<Scalars['Boolean']>;
  learnMoreUrl?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  purposeAnswer?: InputMaybe<Scalars['String']>;
  purposeQuestion?: InputMaybe<Scalars['String']>;
  purposeTF?: InputMaybe<Scalars['Boolean']>;
  quickStart?: InputMaybe<Scalars['Boolean']>;
  reportKey?: InputMaybe<Scalars['String']>;
  scatteredInsight?: InputMaybe<Scalars['String']>;
  shortLabel?: InputMaybe<Scalars['String']>;
  showAsTagTF?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type: FeatureType;
};

export type FeatureRepondent = {
  __typename?: 'FeatureRepondent';
  answeredChoices: Scalars['Json'];
  choices: Array<Maybe<Choice>>;
  featureId: Scalars['String'];
  responses: Scalars['Json'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export enum FeatureType {
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  DropdownSingle = 'DROPDOWN_SINGLE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultipleSelectCheckboxes = 'MULTIPLE_SELECT_CHECKBOXES',
  MultipleSelectDropdown = 'MULTIPLE_SELECT_DROPDOWN',
  MultiLine = 'MULTI_LINE',
  MultiOption = 'MULTI_OPTION',
  MultiSelect = 'MULTI_SELECT',
  Rate = 'RATE',
  SingleLineText = 'SINGLE_LINE_TEXT',
  SingleOption = 'SINGLE_OPTION',
  SingleSelectDropdown = 'SINGLE_SELECT_DROPDOWN',
  SingleSelectRadio = 'SINGLE_SELECT_RADIO',
  Text = 'TEXT',
  TextMultiLine = 'TEXT_MULTI_LINE',
  TextSingleLine = 'TEXT_SINGLE_LINE'
}

export type FeatureUpdateInput = {
  accountId?: InputMaybe<Scalars['String']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  choices?: InputMaybe<Array<ChoiceUpdateInput>>;
  definitionAnswer?: InputMaybe<Scalars['String']>;
  definitionQuestion?: InputMaybe<Scalars['String']>;
  definitionTF?: InputMaybe<Scalars['Boolean']>;
  dimensionId: Scalars['String'];
  hasReport?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  learnMoreLabel?: InputMaybe<Scalars['String']>;
  learnMoreTF?: InputMaybe<Scalars['Boolean']>;
  learnMoreUrl?: InputMaybe<Scalars['String']>;
  placeholder?: InputMaybe<Scalars['String']>;
  purposeAnswer?: InputMaybe<Scalars['String']>;
  purposeQuestion?: InputMaybe<Scalars['String']>;
  purposeTF?: InputMaybe<Scalars['Boolean']>;
  quickStart?: InputMaybe<Scalars['Boolean']>;
  reportKey?: InputMaybe<Scalars['String']>;
  scatteredInsight?: InputMaybe<Scalars['String']>;
  shortLabel?: InputMaybe<Scalars['String']>;
  showAsTagTF?: InputMaybe<Scalars['Boolean']>;
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type: FeatureType;
};

export type FilterItemInput = {
  key: Scalars['String'];
  operator?: FilterOperatorType;
  value?: InputMaybe<Scalars['String']>;
  valueBoolean?: InputMaybe<Scalars['Boolean']>;
  valueDate?: InputMaybe<Scalars['DateTime']>;
  valueFloat?: InputMaybe<Scalars['Float']>;
  valueNumber?: InputMaybe<Scalars['Int']>;
};

export enum FilterOperatorType {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export type FinchIntegrationInput = {
  accountId: Scalars['String'];
  accountIntegrationId: Scalars['String'];
  atsName: Scalars['String'];
  authCode: Scalars['String'];
  integrationId: Scalars['String'];
};

export type FinchIntegrationResponse = {
  __typename?: 'FinchIntegrationResponse';
  data?: Maybe<Scalars['Json']>;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FinchSendEmailInput = {
  accountId: Scalars['String'];
};

export type Insight = {
  __typename?: 'Insight';
  insightText?: Maybe<Scalars['String']>;
  leadingQuestion?: Maybe<Scalars['String']>;
  leadingQuestionTipsLink?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Integration = {
  __typename?: 'Integration';
  accountIntegrations: Array<AccountIntegration>;
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type IntegrationCreateInput = {
  createdBy: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
};

export type Intercom = {
  __typename?: 'Intercom';
  accountBoardCount?: Maybe<Scalars['String']>;
  accountUserCount?: Maybe<Scalars['String']>;
  boardEditor?: Maybe<Scalars['String']>;
  boardMembership?: Maybe<Scalars['String']>;
  onFreePlan?: Maybe<Scalars['String']>;
  quickStartComplete?: Maybe<Scalars['String']>;
};

export enum Interval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Invitation = {
  __typename?: 'Invitation';
  code: Scalars['String'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  status: InvitationStatus;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export enum InvitationStatus {
  Active = 'Active',
  Expired = 'Expired',
  Invalid = 'Invalid',
  Used = 'Used'
}

export type InviteBoardInput = {
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type InviteMemberToAccountResponse = {
  __typename?: 'InviteMemberToAccountResponse';
  addedUsers: Array<Scalars['String']>;
  alreadyExistUsers: Array<Scalars['String']>;
};

export type InviteSelectedBoardInput = {
  boardId: Scalars['String'];
  userId: Scalars['String'];
};

export type InviteSelectedBoardResponse = {
  __typename?: 'InviteSelectedBoardResponse';
  addedMembers: Array<BoardMember>;
  alreadyExistMembers: Array<BoardMember>;
};

export type InviteUsersToAccountInput = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Invoices = {
  __typename?: 'Invoices';
  description?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  invoiceUrl?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum Mindset {
  Balancer = 'Balancer',
  Driver = 'Driver',
  Juggler = 'Juggler',
  Saver = 'Saver',
  Traveler = 'Traveler'
}

export type Mutation = {
  __typename?: 'Mutation';
  cancelSubscription: Subscription;
  changeSubscriptionBilling: ChangeSubscriptionBillingEmailResponse;
  changeSubscriptionPaymentMethod: ChangeSubscriptionPaymentMethodResponse;
  changeSubscriptionPlan: ChangePlanResponse;
  changeTeamSize: Subscription;
  createAccount: Account;
  createAccountIntegration: AccountIntegration;
  createAccountPreview: Account;
  createBoard: CreateUpdateBoardReponse;
  createContactLluna: ContactLluna;
  createDimension: Dimension;
  createFeature: Feature;
  createPlainAccount: Account;
  createReadme: ReadMe;
  createSubscription: Subscription;
  createSubscriptionForAccount: SubscriptionResponse;
  createTeamMember: User;
  createUser: User;
  deleteBoard: CreateUpdateBoardReponse;
  deleteUser: User;
  disconnectSlackIntegration: Account;
  forcefullyVerifyUser: UserVerifyResponse;
  inviteMemberToAccount: InviteMemberToAccountResponse;
  inviteToBoard: InviteSelectedBoardResponse;
  markNotificationReader: CreateNotificationReaderRes;
  removeDimension: Dimension;
  removeFeature: Feature;
  sendPasswordResetLink: Scalars['Boolean'];
  sendUpdateRemainder: Scalars['Boolean'];
  shareReadme: ReadMe;
  stripeCreateCustomerPortalSession: Scalars['String'];
  stripeCreatePaymentIntent: StripePaymentIntent;
  stripeSetupPaymentIntent: StripePaymentIntent;
  submitAuthCode: FinchIntegrationResponse;
  switchToFreeAccount: Account;
  syncFirebaseUser: User;
  toggleUsers: Scalars['Boolean'];
  updateAccountIntegration: AccountIntegration;
  updateBoard: CreateUpdateBoardReponse;
  updateCurrentUserPoll: User;
  updateDimension: Dimension;
  updateFeature: Feature;
  updateLastLoggedIn: User;
  updateLlunaAccount: Account;
  updateMindsets: User;
  updateProfile: Profile;
  updateProfileAvatar: Profile;
  updateProfilePreview: Profile;
  updateReadme: ReadMe;
  updateSignupProfile: Profile;
  updateSubscriptionWithInvite: InviteMemberToAccountResponse;
  updateUserMetaData: User;
  updateUserSignup: User;
};


export type MutationChangeSubscriptionBillingArgs = {
  input: ChangeSubscriptionBillingEmail;
};


export type MutationChangeSubscriptionPaymentMethodArgs = {
  input: ChangeSubscriptionPaymentMethod;
};


export type MutationChangeSubscriptionPlanArgs = {
  input: ChangePlanInput;
};


export type MutationChangeTeamSizeArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateAccountIntegrationArgs = {
  input: CreateAccountIntegrationInput;
};


export type MutationCreateAccountPreviewArgs = {
  input: AccountInput;
};


export type MutationCreateBoardArgs = {
  input: CreateBoardInput;
};


export type MutationCreateContactLlunaArgs = {
  input: CreateContactLlunaInput;
};


export type MutationCreateDimensionArgs = {
  data: DimensionInput;
};


export type MutationCreateFeatureArgs = {
  data: FeatureCreateInput;
};


export type MutationCreatePlainAccountArgs = {
  input: PlainAccountInput;
};


export type MutationCreateReadmeArgs = {
  input: CreateReadmeInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionForAccountArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateTeamMemberArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserArgs = {
  input: CreatePlainUserInput;
};


export type MutationDeleteBoardArgs = {
  input: DeleteBoardInput;
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String'];
};


export type MutationDisconnectSlackIntegrationArgs = {
  accountId: Scalars['String'];
};


export type MutationForcefullyVerifyUserArgs = {
  input?: InputMaybe<UserEmailInput>;
};


export type MutationInviteMemberToAccountArgs = {
  input?: InputMaybe<InviteUsersToAccountInput>;
};


export type MutationInviteToBoardArgs = {
  input?: InputMaybe<Array<InputMaybe<InviteSelectedBoardInput>>>;
};


export type MutationMarkNotificationReaderArgs = {
  input: CreateNotificationReaderInput;
};


export type MutationRemoveDimensionArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFeatureArgs = {
  id: Scalars['String'];
};


export type MutationSendPasswordResetLinkArgs = {
  input: UserEmailInput;
};


export type MutationSendUpdateRemainderArgs = {
  input: SendUpdateRemainderInput;
};


export type MutationShareReadmeArgs = {
  input: ShareReadMeInput;
};


export type MutationStripeCreatePaymentIntentArgs = {
  amount: Scalars['String'];
};


export type MutationSubmitAuthCodeArgs = {
  input: FinchIntegrationInput;
};


export type MutationSwitchToFreeAccountArgs = {
  accountId: Scalars['String'];
};


export type MutationSyncFirebaseUserArgs = {
  email: Scalars['String'];
  sso: Scalars['Boolean'];
};


export type MutationToggleUsersArgs = {
  isEnabled: Scalars['Boolean'];
  userIds: Array<Scalars['ID']>;
};


export type MutationUpdateAccountIntegrationArgs = {
  input: UpdateAccountIntegrationInput;
};


export type MutationUpdateBoardArgs = {
  input: UpdateBoardInput;
};


export type MutationUpdateCurrentUserPollArgs = {
  pollResult?: InputMaybe<Scalars['Json']>;
};


export type MutationUpdateDimensionArgs = {
  data: DimensionUpdateInput;
};


export type MutationUpdateFeatureArgs = {
  data: FeatureUpdateInput;
};


export type MutationUpdateLlunaAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateMindsetsArgs = {
  primary?: InputMaybe<Mindset>;
  secondary?: InputMaybe<Mindset>;
};


export type MutationUpdateProfileArgs = {
  input: ProfileUpdateInput;
};


export type MutationUpdateProfileAvatarArgs = {
  src?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProfilePreviewArgs = {
  input: ProfileUpdateInput;
};


export type MutationUpdateReadmeArgs = {
  input: UpdateReadmeInput;
};


export type MutationUpdateSignupProfileArgs = {
  input: SignupProfileInput;
};


export type MutationUpdateSubscriptionWithInviteArgs = {
  input: UpdateSubscriptionWithInvite;
};


export type MutationUpdateUserMetaDataArgs = {
  input: UserMetaDataInput;
};


export type MutationUpdateUserSignupArgs = {
  input?: InputMaybe<UpdateUserInput>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  message: Scalars['String'];
  notificationReader: Array<NotificationReader>;
  senderId: Scalars['String'];
  status: Scalars['Boolean'];
  type: Array<NotificationType>;
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type NotificationReader = {
  __typename?: 'NotificationReader';
  id: Scalars['ID'];
  notificationId: Scalars['String'];
  readerId: Scalars['String'];
  state: Array<NotificationState>;
};

export enum NotificationState {
  Read = 'READ',
  Unread = 'UNREAD'
}

export enum NotificationType {
  Readme = 'README'
}

export type OrderByItemInput = {
  key: Scalars['String'];
  order: OrderType;
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Placeholder {
  Days = 'DAYS',
  Hours = 'HOURS',
  Months = 'MONTHS',
  Percentage = 'PERCENTAGE',
  Usd = 'USD',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

export type PlainAccountInput = {
  integrationCollaboration?: InputMaybe<Scalars['Boolean']>;
  integrationHRIS?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  subscriptionId?: InputMaybe<Scalars['String']>;
  teamName: Scalars['String'];
  useStripe: Scalars['Boolean'];
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  liveStripeProductId?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['Json']>;
  name: Scalars['String'];
  prices: Array<PlanPrice>;
  testStripeProductId?: Maybe<Scalars['String']>;
};

export type PlanPrice = {
  __typename?: 'PlanPrice';
  id: Scalars['ID'];
  interval: Interval;
  intervalCount: Scalars['Int'];
  isActive: Scalars['Boolean'];
  liveStripePriceId?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['Json']>;
  name?: Maybe<Scalars['String']>;
  plan: Plan;
  pricePerUnit: Scalars['Float'];
  subscriptions: Array<Subscription>;
  testStripePriceId?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  additionalPermissions?: Maybe<UserAdditionalPermissions>;
  addresses: Array<Address>;
  avatar?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  customSharableString?: Maybe<Scalars['String']>;
  filterScope?: Maybe<Scalars['Json']>;
  fullName: Scalars['String'];
  function?: Maybe<Scalars['String']>;
  hireDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  jobRole?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  objects?: Maybe<Scalars['String']>;
  officeLocation?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  possessives?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<UserRole>>;
  subjects?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type ProfileUpdateInput = {
  additionalPermissions?: InputMaybe<Array<InputMaybe<UserAdditionalPermissions>>>;
  companyName?: InputMaybe<Scalars['String']>;
  customSharableString?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  filterScope?: InputMaybe<Scalars['Json']>;
  function?: InputMaybe<Scalars['String']>;
  hireDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  industry?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  objects?: InputMaybe<Scalars['String']>;
  officeLocation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  possessives?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>>>;
  subjects?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accountIntegration: Array<AccountIntegration>;
  accountSubscription?: Maybe<Subscription>;
  accountUser?: Maybe<User>;
  accountUserByEmail?: Maybe<User>;
  accountUsers: Users;
  accounts: Array<Account>;
  boardPOPCompletedMembers: Array<BoardMember>;
  boardRosters: BoardRosters;
  boardRostersFeatureRespondent: Array<FeatureRepondent>;
  boardViewers: Array<BoardReportViewer>;
  boardViewersPreview: Array<BoardReportViewer>;
  boards: Array<Board>;
  checkInvitation: Invitation;
  currentAccountUsers: Users;
  currentUserAccountUsers: Array<User>;
  customerPaymentMethods: Array<CustomerPaymentMethodsResponse>;
  dashboard?: Maybe<Dashboard>;
  dimension?: Maybe<Dimension>;
  dimensions: Array<Dimension>;
  feature?: Maybe<Feature>;
  features: Array<Feature>;
  getStripeCoupon: Array<StipeCoupons>;
  integrations: Array<Integration>;
  inviteBoard: Array<Board>;
  me?: Maybe<User>;
  notifications: Array<Notification>;
  popUrl: Array<EmailPopData>;
  profile?: Maybe<Profile>;
  profiles: Array<Profile>;
  readMe?: Maybe<ReadMe>;
  readMeForShare?: Maybe<ReadMeForShare>;
  readMeSharableInfo?: Maybe<ReadMe>;
  searchUsers: Array<User>;
  subscription?: Maybe<Subscription>;
  subscriptionPlans: Array<Plan>;
  subscriptions: Array<Subscription>;
  userScopes: UserScope;
};


export type QueryAccountUserArgs = {
  id: Scalars['String'];
};


export type QueryAccountUserByEmailArgs = {
  email: Scalars['String'];
};


export type QueryAccountUsersArgs = {
  accountId: Scalars['String'];
  input: TableDataInput;
};


export type QueryAccountsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryBoardRostersArgs = {
  boardId: Scalars['String'];
};


export type QueryBoardRostersFeatureRespondentArgs = {
  boardId: Scalars['String'];
  featureId: Scalars['String'];
};


export type QueryBoardViewersArgs = {
  boardId: Scalars['String'];
};


export type QueryBoardViewersPreviewArgs = {
  boardId: Scalars['String'];
};


export type QueryCheckInvitationArgs = {
  invitationCode: Scalars['String'];
};


export type QueryCurrentAccountUsersArgs = {
  input: TableDataInput;
};


export type QueryDimensionArgs = {
  id: Scalars['ID'];
};


export type QueryFeatureArgs = {
  id: Scalars['ID'];
};


export type QueryFeaturesArgs = {
  input: TableDataInput;
};


export type QueryGetStripeCouponArgs = {
  code: Scalars['String'];
};


export type QueryInviteBoardArgs = {
  input: InviteBoardInput;
};


export type QueryNotificationsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryPopUrlArgs = {
  input?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryProfileArgs = {
  id: Scalars['ID'];
};


export type QueryReadMeArgs = {
  userId: Scalars['String'];
};


export type QueryReadMeSharableInfoArgs = {
  input: SharedReadMeViewInput;
};


export type QuerySearchUsersArgs = {
  input: SearchUserInput;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};

export type ReadMe = {
  __typename?: 'ReadMe';
  aboutMe?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  quickStartComplete?: Maybe<Scalars['Boolean']>;
  responses?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
  views?: Maybe<Scalars['String']>;
};

export type ReadMeForShare = {
  __typename?: 'ReadMeForShare';
  aboutMe: Scalars['String'];
  customString: Scalars['String'];
  id: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type SearchUserInput = {
  accountId: Scalars['String'];
  text: Scalars['String'];
};

export type SearchUsers = {
  __typename?: 'SearchUsers';
  users: Array<User>;
};

export type SectionFeature = {
  __typename?: 'SectionFeature';
  displayType: Scalars['String'];
  featureAndRespondents: Array<Maybe<BoardViewerFeature>>;
  insights?: Maybe<Array<Maybe<Insight>>>;
};

export type ShareReadMeInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  readMeId: Scalars['String'];
  sharableLink: Scalars['String'];
  sharedWithEmailId: Array<Scalars['String']>;
};

export type SharedReadMeViewInput = {
  customSharableString: Scalars['String'];
  ip?: InputMaybe<Scalars['String']>;
};

export type SignupProfileInput = {
  companyName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  industry?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type SlackworkSpace = {
  __typename?: 'SlackworkSpace';
  team_id: Scalars['String'];
  team_name: Scalars['String'];
};

export type StipeCoupons = {
  __typename?: 'StipeCoupons';
  active?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  coupon?: Maybe<Scalars['Json']>;
  id?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  clientSecret?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  account: Account;
  accountId: Scalars['String'];
  active: Scalars['Boolean'];
  activeFrom: Scalars['DateTime'];
  activeTo: Scalars['DateTime'];
  billingAction?: Maybe<BillingAction>;
  id: Scalars['ID'];
  interval?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Invoices>>;
  isTrial: Scalars['Boolean'];
  plan?: Maybe<PlanPrice>;
  seats: Scalars['Int'];
  seatsTaken: Scalars['Int'];
  stripeSubscriptionId?: Maybe<Scalars['String']>;
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  message?: Maybe<Scalars['String']>;
  plus?: Maybe<Subscription>;
};

export type TableDataInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterItemInput>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<OrderByItemInput>>;
  take?: InputMaybe<Scalars['Int']>;
  userScope?: InputMaybe<Scalars['Json']>;
};

export type UniqueProfileFields = {
  __typename?: 'UniqueProfileFields';
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type UpdateAccountInput = {
  accountId: Scalars['String'];
  actionKey?: InputMaybe<Scalars['String']>;
  integrationCollaboration?: InputMaybe<Scalars['Boolean']>;
  integrationHRIS?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  teamName?: InputMaybe<Scalars['String']>;
  useStripe?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAccountIntegrationInput = {
  accessToken: Scalars['String'];
  accountId: Scalars['String'];
  atsName: Scalars['String'];
  id: Scalars['String'];
  integrationId: Scalars['String'];
  integrationProviderDetails?: InputMaybe<Scalars['Json']>;
  manual?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['String'];
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateBoardInput = {
  boardId: Scalars['String'];
  boardMember?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  boardViewer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateReadmeInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  quickStartComplete?: InputMaybe<Scalars['Boolean']>;
  responses?: InputMaybe<Scalars['Json']>;
  updatedFeature?: InputMaybe<Scalars['Json']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateSubscriptionInput = {
  /** ID of selected planPrice item */
  planPriceId: Scalars['String'];
  /** Number of seats */
  quantity: Scalars['Int'];
};

export type UpdateSubscriptionWithInvite = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of selected planPrice item */
  planPriceId: Scalars['String'];
  /** Number of seats */
  quantity: Scalars['Int'];
};

export type UpdateUserInput = {
  email: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  account?: Maybe<Account>;
  activity?: Maybe<Scalars['String']>;
  additionalPermissions: Array<UserAdditionalPermissions>;
  boardMember: Array<BoardMember>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  filterScope?: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  intercomData?: Maybe<Intercom>;
  isEnabled: Scalars['Boolean'];
  isInvited?: Maybe<Scalars['Boolean']>;
  isOnboardingPollComplete: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  meta?: Maybe<Scalars['Json']>;
  mindSet?: Maybe<Scalars['String']>;
  onFreePlan: Scalars['Boolean'];
  profile?: Maybe<Profile>;
  readMe: Array<ReadMe>;
  roles: Array<UserRole>;
  slackUserId?: Maybe<Scalars['String']>;
  slackWorkspace?: Maybe<SlackworkSpace>;
};

export enum UserAdditionalPermissions {
  FrameworkManager = 'FRAMEWORK_MANAGER',
  ReportViewer = 'REPORT_VIEWER'
}

export type UserEmailInput = {
  email: Scalars['String'];
};

export type UserInput = {
  email: Scalars['String'];
  firebaseId: Scalars['String'];
  firebaseProvider: Scalars['String'];
};

export type UserMetaDataInput = {
  field: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Json']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  LlunaAdmin = 'LLUNA_ADMIN',
  Member = 'MEMBER',
  PrimaryAdmin = 'PRIMARY_ADMIN'
}

export type UserScope = {
  __typename?: 'UserScope';
  accountId: Scalars['String'];
  functions: Array<Scalars['String']>;
  jobTitles: Array<Scalars['String']>;
  officeLocation: Array<Scalars['String']>;
};

export type UserVerifyResponse = {
  __typename?: 'UserVerifyResponse';
  msg?: Maybe<Scalars['String']>;
};

export type UserWithAnswer = {
  __typename?: 'UserWithAnswer';
  answer: Scalars['String'];
  mindSet: Scalars['String'];
  user?: Maybe<User>;
};

export type Users = {
  __typename?: 'Users';
  cursor?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  users: Array<User>;
};

export type SendUpdateRemainderInput = {
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SendPasswordResetLinkMutationVariables = Exact<{
  input: UserEmailInput;
}>;


export type SendPasswordResetLinkMutation = { __typename?: 'Mutation', sendPasswordResetLink: boolean };

export type CreateAccountMutationVariables = Exact<{
  input: AccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', users: Array<{ __typename?: 'User', id: string, roles: Array<UserRole>, isOnboardingPollComplete: boolean }> } };

export type CreatePlainAccountMutationVariables = Exact<{
  input: PlainAccountInput;
}>;


export type CreatePlainAccountMutation = { __typename?: 'Mutation', createPlainAccount: { __typename?: 'Account', id: string, name?: string | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'Subscription', id: string, activeFrom: any, activeTo: any, isTrial: boolean, active: boolean, seats: number, seatsTaken: number, plan?: { __typename?: 'PlanPrice', id: string, pricePerUnit: number } | null } };

export type UpdateSubscriptionWithInviteMutationVariables = Exact<{
  input: UpdateSubscriptionWithInvite;
}>;


export type UpdateSubscriptionWithInviteMutation = { __typename?: 'Mutation', updateSubscriptionWithInvite: { __typename?: 'InviteMemberToAccountResponse', addedUsers: Array<string>, alreadyExistUsers: Array<string> } };

export type UpdateLlunaAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateLlunaAccountMutation = { __typename?: 'Mutation', updateLlunaAccount: { __typename?: 'Account', id: string, integrationCollaboration?: boolean | null, integrationHRIS?: boolean | null, subscriptionId?: string | null, actionKey?: string | null } };

export type InviteMemberToAccountMutationVariables = Exact<{
  input?: InputMaybe<InviteUsersToAccountInput>;
}>;


export type InviteMemberToAccountMutation = { __typename?: 'Mutation', inviteMemberToAccount: { __typename?: 'InviteMemberToAccountResponse', addedUsers: Array<string>, alreadyExistUsers: Array<string> } };

export type CreateSubscriptionForAccountMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionForAccountMutation = { __typename?: 'Mutation', createSubscriptionForAccount: { __typename?: 'SubscriptionResponse', message?: string | null, plus?: { __typename?: 'Subscription', id: string, activeFrom: any, activeTo: any, isTrial: boolean, plan?: { __typename?: 'PlanPrice', interval: Interval } | null } | null } };

export type CreateContactLlunaMutationVariables = Exact<{
  input: CreateContactLlunaInput;
}>;


export type CreateContactLlunaMutation = { __typename?: 'Mutation', createContactLluna: { __typename?: 'ContactLluna', email: string } };

export type ChangeSubscriptionPlanMutationVariables = Exact<{
  input: ChangePlanInput;
}>;


export type ChangeSubscriptionPlanMutation = { __typename?: 'Mutation', changeSubscriptionPlan: { __typename?: 'ChangePlanResponse', message: string } };

export type ChangeSubscriptionPaymentMethodMutationVariables = Exact<{
  input: ChangeSubscriptionPaymentMethod;
}>;


export type ChangeSubscriptionPaymentMethodMutation = { __typename?: 'Mutation', changeSubscriptionPaymentMethod: { __typename?: 'ChangeSubscriptionPaymentMethodResponse', message: string } };

export type ChangeTeamSizeMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type ChangeTeamSizeMutation = { __typename?: 'Mutation', changeTeamSize: { __typename?: 'Subscription', seats: number, seatsTaken: number, stripeSubscriptionId?: string | null } };

export type ChangeSubscriptionBillingMutationVariables = Exact<{
  input: ChangeSubscriptionBillingEmail;
}>;


export type ChangeSubscriptionBillingMutation = { __typename?: 'Mutation', changeSubscriptionBilling: { __typename?: 'ChangeSubscriptionBillingEmailResponse', message: string } };

export type DisconnectSlackIntegrationMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type DisconnectSlackIntegrationMutation = { __typename?: 'Mutation', disconnectSlackIntegration: { __typename?: 'Account', slackWorkspaceId?: string | null } };

export type AccountUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type AccountUserByEmailQuery = { __typename?: 'Query', accountUserByEmail?: { __typename?: 'User', email: string, id: string, isVerified: boolean, isInvited?: boolean | null, profile?: { __typename?: 'Profile', fullName: string, surname?: string | null, name?: string | null } | null } | null };

export type CreateBoardMutationVariables = Exact<{
  input: CreateBoardInput;
}>;


export type CreateBoardMutation = { __typename?: 'Mutation', createBoard: { __typename?: 'CreateUpdateBoardReponse', id: string, name: string, editor: string } };

export type UpdateBoardMutationVariables = Exact<{
  input: UpdateBoardInput;
}>;


export type UpdateBoardMutation = { __typename?: 'Mutation', updateBoard: { __typename?: 'CreateUpdateBoardReponse', id: string, name: string, editor: string } };

export type DeleteBoardMutationVariables = Exact<{
  input: DeleteBoardInput;
}>;


export type DeleteBoardMutation = { __typename?: 'Mutation', deleteBoard: { __typename?: 'CreateUpdateBoardReponse', id: string, name: string } };

export type InviteToBoardMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<InviteSelectedBoardInput>> | InputMaybe<InviteSelectedBoardInput>>;
}>;


export type InviteToBoardMutation = { __typename?: 'Mutation', inviteToBoard: { __typename?: 'InviteSelectedBoardResponse', addedMembers: Array<{ __typename?: 'BoardMember', id: string, userId: string, boardId: string }>, alreadyExistMembers: Array<{ __typename?: 'BoardMember', id: string, userId: string, boardId: string }> } };

export type SendUpdateRemainderMutationVariables = Exact<{
  input: SendUpdateRemainderInput;
}>;


export type SendUpdateRemainderMutation = { __typename?: 'Mutation', sendUpdateRemainder: boolean };

export type BoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type BoardsQuery = { __typename?: 'Query', boards: Array<{ __typename?: 'Board', id: string, name?: string | null, editor?: string | null, editorUser?: { __typename?: 'User', id: string, email: string, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null }> } | null, boardMember: Array<{ __typename?: 'BoardMember', id: string, boardId: string, userId: string, user: { __typename?: 'User', id: string, readMe: Array<{ __typename?: 'ReadMe', id: string, quickStartComplete?: boolean | null, userId: string }> } }>, boardViewer: Array<{ __typename?: 'BoardViewer', id: string, userId: string, boardId: string }> }> };

export type BoardRosterQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardRosterQuery = { __typename?: 'Query', boardRosters: { __typename?: 'BoardRosters', members: Array<{ __typename?: 'BoardRosterUser', boardId?: string | null, user?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', avatar?: string | null, fullName: string, customSharableString?: string | null } | null, readMe: Array<{ __typename?: 'ReadMe', responses?: any | null, quickStartComplete?: boolean | null }> } | null } | null>, features: Array<{ __typename?: 'Feature', id: string, shortLabel?: string | null, showAsTagTF?: boolean | null, type: FeatureType, choices: Array<{ __typename?: 'Choice', shortChoiceLabel?: string | null, id: string }>, dimension: { __typename?: 'Dimension', id: string } } | null>, board?: { __typename?: 'BoardDetails', name: string } | null }, dimensions: Array<{ __typename?: 'Dimension', id: string, meta?: any | null, name: string, order?: number | null }> };

export type BoardRostersFeatureRespondentQueryVariables = Exact<{
  boardId: Scalars['String'];
  featureId: Scalars['String'];
}>;


export type BoardRostersFeatureRespondentQuery = { __typename?: 'Query', boardRostersFeatureRespondent: Array<{ __typename?: 'FeatureRepondent', answeredChoices: any, choices: Array<{ __typename?: 'Choice', id: string, shortChoiceLabel?: string | null } | null>, user?: { __typename?: 'User', id: string } | null }> };

export type BoardViewersQueryVariables = Exact<{
  boardId: Scalars['String'];
}>;


export type BoardViewersQuery = { __typename?: 'Query', boardViewers: Array<{ __typename?: 'BoardReportViewer', sectionHeader: string, sectionFeatures: Array<{ __typename?: 'SectionFeature', displayType: string, featureAndRespondents: Array<{ __typename?: 'BoardViewerFeature', feature: { __typename?: 'Feature', text: string, id: string, shortLabel?: string | null, showAsTagTF?: boolean | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null }, answeredChoices?: Array<{ __typename?: 'AnsweredChoice', choice: { __typename?: 'Choice', id: string, shortChoiceLabel?: string | null, text: string }, users: Array<{ __typename?: 'User', id: string, mindSet?: string | null, profile?: { __typename?: 'Profile', avatar?: string | null, customSharableString?: string | null, id: string, surname?: string | null, name?: string | null } | null, readMe: Array<{ __typename?: 'ReadMe', responses?: any | null, quickStartComplete?: boolean | null }> } | null> } | null> | null, answeredTexts?: Array<{ __typename?: 'UserWithAnswer', answer: string, mindSet: string, user?: { __typename?: 'User', id: string, mindSet?: string | null, profile?: { __typename?: 'Profile', avatar?: string | null, customSharableString?: string | null, id: string, surname?: string | null, name?: string | null } | null, readMe: Array<{ __typename?: 'ReadMe', responses?: any | null, quickStartComplete?: boolean | null }> } | null } | null> | null, insights?: Array<{ __typename?: 'Insight', insightText?: string | null, leadingQuestion?: string | null, leadingQuestionTipsLink?: string | null, linkText?: string | null, type?: string | null } | null> | null } | null>, insights?: Array<{ __typename?: 'Insight', insightText?: string | null, leadingQuestion?: string | null, leadingQuestionTipsLink?: string | null, linkText?: string | null, type?: string | null } | null> | null } | null>, board?: { __typename?: 'BoardDetails', name: string, boardMember: Array<{ __typename?: 'BoardMemberData', user: { __typename?: 'User', id: string } }>, editorUser?: { __typename?: 'User', id: string } | null } | null }> };

export type DimensionDataFragment = { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> };

export type CreateDimensionMutationVariables = Exact<{
  input: DimensionInput;
}>;


export type CreateDimensionMutation = { __typename?: 'Mutation', createDimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> } };

export type UpdateDimensionMutationVariables = Exact<{
  input: DimensionUpdateInput;
}>;


export type UpdateDimensionMutation = { __typename?: 'Mutation', updateDimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> } };

export type RemoveDimensionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveDimensionMutation = { __typename?: 'Mutation', removeDimension: { __typename?: 'Dimension', id: string } };

export type DimensionsQueryVariables = Exact<{ [key: string]: never; }>;


export type DimensionsQuery = { __typename?: 'Query', dimensions: Array<{ __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }> };

export type DimensionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DimensionQuery = { __typename?: 'Query', dimension?: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> } | null };

export type FeatureDataFragment = { __typename?: 'Feature', id: string, text: string, title?: string | null, type: FeatureType, accountId?: string | null, hasReport?: boolean | null, reportKey?: string | null, quickStart?: boolean | null, shortLabel?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, additionalComments?: string | null, placeholder?: string | null, scatteredInsight?: string | null, showAsTagTF?: boolean | null, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null }> };

export type ChoiceDataFragment = { __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null };

export type CreateFeatureMutationVariables = Exact<{
  data: FeatureCreateInput;
}>;


export type CreateFeatureMutation = { __typename?: 'Mutation', createFeature: { __typename?: 'Feature', id: string, text: string, title?: string | null, type: FeatureType, accountId?: string | null, hasReport?: boolean | null, reportKey?: string | null, quickStart?: boolean | null, shortLabel?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, additionalComments?: string | null, placeholder?: string | null, scatteredInsight?: string | null, showAsTagTF?: boolean | null, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null }> } };

export type RemoveFeatureMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveFeatureMutation = { __typename?: 'Mutation', removeFeature: { __typename?: 'Feature', id: string, text: string, type: FeatureType } };

export type UpdateFeatureMutationVariables = Exact<{
  data: FeatureUpdateInput;
}>;


export type UpdateFeatureMutation = { __typename?: 'Mutation', updateFeature: { __typename?: 'Feature', id: string, text: string, title?: string | null, type: FeatureType, accountId?: string | null, hasReport?: boolean | null, reportKey?: string | null, quickStart?: boolean | null, shortLabel?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, additionalComments?: string | null, placeholder?: string | null, scatteredInsight?: string | null, showAsTagTF?: boolean | null, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null }> } };

export type FeaturesQueryVariables = Exact<{
  input: TableDataInput;
}>;


export type FeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'Feature', id: string, text: string, title?: string | null, type: FeatureType, accountId?: string | null, hasReport?: boolean | null, reportKey?: string | null, quickStart?: boolean | null, shortLabel?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, additionalComments?: string | null, placeholder?: string | null, scatteredInsight?: string | null, showAsTagTF?: boolean | null, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null }> }> };

export type FeatureQueryVariables = Exact<{
  featureId: Scalars['ID'];
}>;


export type FeatureQuery = { __typename?: 'Query', feature?: { __typename?: 'Feature', id: string, text: string, title?: string | null, type: FeatureType, accountId?: string | null, hasReport?: boolean | null, reportKey?: string | null, quickStart?: boolean | null, shortLabel?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, additionalComments?: string | null, placeholder?: string | null, scatteredInsight?: string | null, showAsTagTF?: boolean | null, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, accountId?: string | null, text: string, type: FeatureType, quickStart?: boolean | null, placeholder?: string | null, additionalComments?: string | null, definitionTF?: boolean | null, definitionQuestion?: string | null, definitionAnswer?: string | null, purposeTF?: boolean | null, purposeQuestion?: string | null, purposeAnswer?: string | null, learnMoreTF?: boolean | null, learnMoreLabel?: string | null, learnMoreUrl?: string | null, shortLabel?: string | null, choices: Array<{ __typename?: 'Choice', id: string, text: string, order?: number | null, placeholderValue?: any | null, placeholderText?: string | null, key?: string | null }>, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null } }> }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, text: string, placeholderValue?: any | null, placeholderText?: string | null }> } | null };

export type AccountsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: string, name?: string | null, integrationCollaboration?: boolean | null, integrationHRIS?: boolean | null, isStripeCustomer: boolean, subscriptionId?: string | null, users: Array<{ __typename?: 'User', email: string, profile?: { __typename?: 'Profile', fullName: string } | null }>, subscriptions: Array<{ __typename?: 'Subscription', stripeSubscriptionId?: string | null, id: string }> }> };

export type SubmitAuthCodeMutationVariables = Exact<{
  input: FinchIntegrationInput;
}>;


export type SubmitAuthCodeMutation = { __typename?: 'Mutation', submitAuthCode: { __typename?: 'FinchIntegrationResponse', status: string, message: string } };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { __typename?: 'Query', integrations: Array<{ __typename?: 'Integration', id: string, name: string, status: string, accountIntegrations: Array<{ __typename?: 'AccountIntegration', id: string, accountId?: string | null, accessToken: string, status: string, atsName: string }> }> };

export type CheckInvitationQueryVariables = Exact<{
  invitationCode: Scalars['String'];
}>;


export type CheckInvitationQuery = { __typename?: 'Query', checkInvitation: { __typename?: 'Invitation', status: InvitationStatus, user?: { __typename?: 'User', email: string, profile?: { __typename?: 'Profile', name?: string | null, surname?: string | null } | null } | null } };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'Plan', id: string, isActive: boolean, liveStripeProductId?: string | null, meta?: any | null, name: string, testStripeProductId?: string | null, prices: Array<{ __typename?: 'PlanPrice', id: string, testStripePriceId?: string | null, liveStripePriceId?: string | null, isActive: boolean, pricePerUnit: number, interval: Interval, meta?: any | null, name?: string | null }> }> };

export type GetStripeCouponQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetStripeCouponQuery = { __typename?: 'Query', getStripeCoupon: Array<{ __typename?: 'StipeCoupons', active?: string | null, code?: string | null, coupon?: any | null, id?: string | null, object?: string | null }> };

export type ReadMeSharableInfoQueryVariables = Exact<{
  input: SharedReadMeViewInput;
}>;


export type ReadMeSharableInfoQuery = { __typename?: 'Query', readMeSharableInfo?: { __typename?: 'ReadMe', responses?: any | null, aboutMe?: string | null, user: { __typename?: 'User', profile?: { __typename?: 'Profile', avatar?: string | null, id: string, name?: string | null, surname?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, timeZone?: string | null, phoneNumber?: string | null, industry?: string | null, objects?: string | null, subjects?: string | null, companyName?: string | null, jobRole?: string | null, possessives?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null } } | null };

export type ProfileDataFragment = { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> };

export type ProfileUpdateMutationVariables = Exact<{
  input: ProfileUpdateInput;
}>;


export type ProfileUpdateMutation = { __typename?: 'Mutation', updateProfile: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } };

export type UpdateProfileAvatarMutationVariables = Exact<{
  src: Scalars['String'];
}>;


export type UpdateProfileAvatarMutation = { __typename?: 'Mutation', updateProfileAvatar: { __typename?: 'Profile', avatar?: string | null, id: string } };

export type UpdateSignupProfileMutationVariables = Exact<{
  input: SignupProfileInput;
}>;


export type UpdateSignupProfileMutation = { __typename?: 'Mutation', updateSignupProfile: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, fullName: string, companyName?: string | null, industry?: string | null, jobTitle?: string | null, jobRole?: string | null, timeZone?: string | null } };

export type CreateReadmeMutationVariables = Exact<{
  input: CreateReadmeInput;
}>;


export type CreateReadmeMutation = { __typename?: 'Mutation', createReadme: { __typename?: 'ReadMe', id: string, quickStartComplete?: boolean | null, aboutMe?: string | null, responses?: any | null, userId: string } };

export type UpdateReadmeMutationVariables = Exact<{
  input: UpdateReadmeInput;
}>;


export type UpdateReadmeMutation = { __typename?: 'Mutation', updateReadme: { __typename?: 'ReadMe', id: string, aboutMe?: string | null, responses?: any | null, userId: string, quickStartComplete?: boolean | null } };

export type ShareReadmeMutationVariables = Exact<{
  input: ShareReadMeInput;
}>;


export type ShareReadmeMutation = { __typename?: 'Mutation', shareReadme: { __typename?: 'ReadMe', id: string } };

export type GetReadMeQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetReadMeQuery = { __typename?: 'Query', readMe?: { __typename?: 'ReadMe', id: string, aboutMe?: string | null, quickStartComplete?: boolean | null, responses?: any | null, userId: string, views?: string | null, updatedAt: any } | null };

export type ReadMeForShareQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadMeForShareQuery = { __typename?: 'Query', readMeForShare?: { __typename?: 'ReadMeForShare', id: string, customString: string } | null };

export type StripeSetupPaymentIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeSetupPaymentIntentMutation = { __typename?: 'Mutation', stripeSetupPaymentIntent: { __typename?: 'StripePaymentIntent', clientSecret?: string | null } };

export type StripeCreateCustomerPortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeCreateCustomerPortalSessionMutation = { __typename?: 'Mutation', stripeCreateCustomerPortalSession: string };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'Subscription', id: string } };

export type CustomerPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerPaymentMethodsQuery = { __typename?: 'Query', customerPaymentMethods: Array<{ __typename?: 'CustomerPaymentMethodsResponse', expireYear?: string | null, expiryMonth?: string | null, last4Digits: string, name: string, paymentMethodId: string, isDefaultPaymentMethod?: boolean | null, type: string }> };

export type AccountUserDataFragment = { __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> };

export type MeDataFragment = { __typename?: 'User', id: string, roles: Array<UserRole>, createdAt: any, email: string, isVerified: boolean, isOnboardingPollComplete: boolean, onFreePlan: boolean, additionalPermissions: Array<UserAdditionalPermissions>, profile?: { __typename?: 'Profile', name?: string | null, surname?: string | null, fullName: string, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null } | null };

export type SubscriptionDataFragment = { __typename?: 'Subscription', id: string, activeFrom: any, activeTo: any, isTrial: boolean, active: boolean, seats: number, seatsTaken: number, stripeSubscriptionId?: string | null, plan?: { __typename?: 'PlanPrice', id: string, pricePerUnit: number, plan: { __typename?: 'Plan', name: string, meta?: any | null } } | null };

export type CreateTeamMemberMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateTeamMemberMutation = { __typename?: 'Mutation', createTeamMember: { __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> } };

export type CreateUserMutationVariables = Exact<{
  input: CreatePlainUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> } };

export type UpdateCurrentUserPollMutationVariables = Exact<{
  pollResult?: InputMaybe<Scalars['Json']>;
}>;


export type UpdateCurrentUserPollMutation = { __typename?: 'Mutation', updateCurrentUserPoll: { __typename?: 'User', id: string, meta?: any | null, isOnboardingPollComplete: boolean } };

export type ToggleUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
  isEnabled: Scalars['Boolean'];
}>;


export type ToggleUsersMutation = { __typename?: 'Mutation', toggleUsers: boolean };

export type UpdateLastLoggedInMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastLoggedInMutation = { __typename?: 'Mutation', updateLastLoggedIn: { __typename?: 'User', id: string, lastLoginAt?: any | null } };

export type MarkNotificationReaderMutationVariables = Exact<{
  input: CreateNotificationReaderInput;
}>;


export type MarkNotificationReaderMutation = { __typename?: 'Mutation', markNotificationReader: { __typename?: 'CreateNotificationReaderRes', count: number } };

export type UpdateSignUpMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateSignUpMutation = { __typename?: 'Mutation', updateUserSignup: { __typename?: 'User', email: string, isVerified: boolean } };

export type VerifyUserMutationVariables = Exact<{
  input?: InputMaybe<UserEmailInput>;
}>;


export type VerifyUserMutation = { __typename?: 'Mutation', forcefullyVerifyUser: { __typename?: 'UserVerifyResponse', msg?: string | null } };

export type SyncFirebaseUserMutationVariables = Exact<{
  email: Scalars['String'];
  sso: Scalars['Boolean'];
}>;


export type SyncFirebaseUserMutation = { __typename?: 'Mutation', syncFirebaseUser: { __typename?: 'User', isVerified: boolean } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email: string, roles: Array<UserRole>, createdAt: any, isVerified: boolean, isOnboardingPollComplete: boolean, onFreePlan: boolean, additionalPermissions: Array<UserAdditionalPermissions>, activity?: string | null, isInvited?: boolean | null, profile?: { __typename?: 'Profile', avatar?: string | null, name?: string | null, surname?: string | null, fullName: string, customSharableString?: string | null } | null, account?: { __typename?: 'Account', name?: string | null, id: string, selectedPlanType?: string | null, isStripeCustomer: boolean, integrationHRIS?: boolean | null, integrationCollaboration?: boolean | null, subscriptionId?: string | null, subscriptions: Array<{ __typename?: 'Subscription', id: string, activeFrom: any, activeTo: any, isTrial: boolean, active: boolean, seats: number, seatsTaken: number, stripeSubscriptionId?: string | null, plan?: { __typename?: 'PlanPrice', id: string, pricePerUnit: number, plan: { __typename?: 'Plan', name: string, meta?: any | null } } | null }> } | null, slackWorkspace?: { __typename?: 'SlackworkSpace', team_id: string, team_name: string } | null, intercomData?: { __typename?: 'Intercom', accountBoardCount?: string | null, accountUserCount?: string | null, boardEditor?: string | null, boardMembership?: string | null, onFreePlan?: string | null, quickStartComplete?: string | null } | null } | null };

export type CurrentAccountUsersQueryVariables = Exact<{
  input: TableDataInput;
}>;


export type CurrentAccountUsersQuery = { __typename?: 'Query', currentAccountUsers: { __typename?: 'Users', cursor?: string | null, total: number, users: Array<{ __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> }> } };

export type AccountUsersQueryVariables = Exact<{
  input: TableDataInput;
  accountId: Scalars['String'];
}>;


export type AccountUsersQuery = { __typename?: 'Query', accountUsers: { __typename?: 'Users', cursor?: string | null, total: number, users: Array<{ __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> }> } };

export type AccountUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type AccountUserQuery = { __typename?: 'Query', accountUser?: { __typename?: 'User', id: string, email: string, isEnabled: boolean, lastLoginAt?: any | null, onFreePlan: boolean, isVerified: boolean, roles: Array<UserRole>, additionalPermissions: Array<UserAdditionalPermissions>, filterScope?: any | null, profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, avatar?: string | null, phoneNumber?: string | null, timeZone?: string | null, function?: string | null, hireDate?: any | null, jobTitle?: string | null, officeLocation?: string | null, additionalPermissions?: UserAdditionalPermissions | null, filterScope?: any | null, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null, industry?: string | null, companyName?: string | null, jobRole?: string | null, addresses: Array<{ __typename?: 'Address', locality?: string | null, lat?: number | null, lng?: number | null }> } | null, account?: { __typename?: 'Account', id: string } | null, boardMember: Array<{ __typename?: 'BoardMember', userId: string, boardId: string }>, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any }> } | null };

export type FwDimensionFragment = { __typename?: 'FWDimension', id: string, name: string, meta?: any | null, features: Array<{ __typename?: 'Feature', id: string, isFollowUp: boolean, text: string, type: FeatureType, dimension: { __typename?: 'Dimension', id: string, name: string, meta?: any | null }, choices: Array<{ __typename?: 'Choice', id: string, order?: number | null, placeholder?: Placeholder | null, placeholderValue?: any | null, placeholderText?: string | null, text: string }> }> };

export type DashboardTeamMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardTeamMemberQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, roles: Array<UserRole>, createdAt: any, email: string, isVerified: boolean, isOnboardingPollComplete: boolean, onFreePlan: boolean, additionalPermissions: Array<UserAdditionalPermissions>, profile?: { __typename?: 'Profile', name?: string | null, surname?: string | null, fullName: string, subjects?: string | null, objects?: string | null, possessives?: string | null, customSharableString?: string | null } | null } | null };

export type UserScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserScopesQuery = { __typename?: 'Query', userScopes: { __typename?: 'UserScope', accountId: string, jobTitles: Array<string>, officeLocation: Array<string>, functions: Array<string> } };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, senderId: string, message: string, type: Array<NotificationType>, updatedAt: any, createdAt: any, status: boolean, user: { __typename?: 'User', profile?: { __typename?: 'Profile', id: string, name?: string | null, surname?: string | null, fullName: string, customSharableString?: string | null } | null, account?: { __typename?: 'Account', id: string } | null }, notificationReader: Array<{ __typename?: 'NotificationReader', state: Array<NotificationState> }> }> };

export type InviteBoardQueryVariables = Exact<{
  input: InviteBoardInput;
}>;


export type InviteBoardQuery = { __typename?: 'Query', inviteBoard: Array<{ __typename?: 'Board', name?: string | null, id: string, status: string, editorUser?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName: string } | null, readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, id: string, updatedAt: any }> } | null, boardViewer: Array<{ __typename?: 'BoardViewer', id: string, userId: string, boardId: string }>, boardMember: Array<{ __typename?: 'BoardMember', id: string, userId: string, boardId: string, user: { __typename?: 'User', readMe: Array<{ __typename?: 'ReadMe', quickStartComplete?: boolean | null, updatedAt: any, id: string }>, profile?: { __typename?: 'Profile', fullName: string } | null } }> }> };

export type AccountSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSubscriptionQuery = { __typename?: 'Query', accountSubscription?: { __typename?: 'Subscription', seats: number, seatsTaken: number, interval?: string | null, activeTo: any, activeFrom: any, accountId: string, id: string, stripeSubscriptionId?: string | null, active: boolean, plan?: { __typename?: 'PlanPrice', testStripePriceId?: string | null, liveStripePriceId?: string | null, isActive: boolean, interval: Interval, intervalCount: number, id: string, pricePerUnit: number, plan: { __typename?: 'Plan', isActive: boolean, liveStripeProductId?: string | null, name: string, meta?: any | null, testStripeProductId?: string | null, id: string, prices: Array<{ __typename?: 'PlanPrice', id: string, isActive: boolean, liveStripePriceId?: string | null, pricePerUnit: number, testStripePriceId?: string | null }> } } | null, billingAction?: { __typename?: 'BillingAction', cardLast4digit?: string | null, supportEmail?: string | null, type?: string | null } | null, invoices?: Array<{ __typename?: 'Invoices', description?: string | null, invoiceId?: string | null, issueDate?: string | null, price?: string | null, status?: string | null, invoiceUrl?: string | null }> | null, account: { __typename?: 'Account', subscriptions: Array<{ __typename?: 'Subscription', plan?: { __typename?: 'PlanPrice', testStripePriceId?: string | null, liveStripePriceId?: string | null, isActive: boolean, id: string, pricePerUnit: number, plan: { __typename?: 'Plan', id: string, isActive: boolean, liveStripeProductId?: string | null, name: string, meta?: any | null, testStripeProductId?: string | null } } | null }> } } | null };

export const DimensionDataFragmentDoc = gql`
    fragment DimensionData on Dimension {
  id
  name
  meta
  features {
    id
    accountId
    text
    type
    quickStart
    placeholder
    additionalComments
    definitionTF
    definitionQuestion
    definitionAnswer
    purposeTF
    purposeQuestion
    purposeAnswer
    learnMoreTF
    learnMoreLabel
    learnMoreUrl
    shortLabel
    choices {
      id
      text
      order
      placeholderValue
      placeholderText
      key
    }
    dimension {
      id
      name
      meta
    }
  }
}
    `;
export const ChoiceDataFragmentDoc = gql`
    fragment ChoiceData on Choice {
  id
  order
  text
  placeholderValue
  placeholderText
}
    `;
export const FeatureDataFragmentDoc = gql`
    fragment FeatureData on Feature {
  id
  text
  title
  type
  accountId
  dimension {
    ...DimensionData
  }
  choices {
    ...ChoiceData
  }
  hasReport
  reportKey
  quickStart
  shortLabel
  definitionTF
  definitionQuestion
  definitionAnswer
  purposeTF
  purposeQuestion
  purposeAnswer
  learnMoreTF
  learnMoreLabel
  learnMoreUrl
  additionalComments
  placeholder
  scatteredInsight
  showAsTagTF
}
    ${DimensionDataFragmentDoc}
${ChoiceDataFragmentDoc}`;
export const ProfileDataFragmentDoc = gql`
    fragment ProfileData on Profile {
  id
  name
  surname
  avatar
  addresses {
    locality
    lat
    lng
  }
  phoneNumber
  timeZone
  function
  hireDate
  jobTitle
  officeLocation
  additionalPermissions
  filterScope
  subjects
  objects
  possessives
  customSharableString
  industry
  companyName
  jobRole
}
    `;
export const AccountUserDataFragmentDoc = gql`
    fragment AccountUserData on User {
  id
  email
  isEnabled
  lastLoginAt
  onFreePlan
  isVerified
  profile {
    ...ProfileData
  }
  roles
  additionalPermissions
  filterScope
  account {
    id
  }
  boardMember {
    userId
    boardId
  }
  readMe {
    quickStartComplete
    updatedAt
  }
}
    ${ProfileDataFragmentDoc}`;
export const MeDataFragmentDoc = gql`
    fragment MeData on User {
  id
  roles
  createdAt
  email
  isVerified
  isOnboardingPollComplete
  onFreePlan
  profile {
    name
    surname
    fullName
    subjects
    objects
    possessives
    customSharableString
  }
  additionalPermissions
}
    `;
export const SubscriptionDataFragmentDoc = gql`
    fragment SubscriptionData on Subscription {
  id
  activeFrom
  activeTo
  isTrial
  active
  seats
  seatsTaken
  stripeSubscriptionId
  plan {
    id
    pricePerUnit
    plan {
      name
      meta
    }
  }
}
    `;
export const FwDimensionFragmentDoc = gql`
    fragment FWDimension on FWDimension {
  id
  name
  meta
  features {
    id
    isFollowUp
    text
    type
    dimension {
      id
      name
      meta
    }
    choices {
      id
      order
      placeholder
      placeholderValue
      placeholderText
      text
    }
  }
}
    `;
export const SendPasswordResetLinkDocument = gql`
    mutation SendPasswordResetLink($input: UserEmailInput!) {
  sendPasswordResetLink(input: $input)
}
    `;
export type SendPasswordResetLinkMutationFn = Apollo.MutationFunction<SendPasswordResetLinkMutation, SendPasswordResetLinkMutationVariables>;

/**
 * __useSendPasswordResetLinkMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetLinkMutation, { data, loading, error }] = useSendPasswordResetLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPasswordResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetLinkMutation, SendPasswordResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetLinkMutation, SendPasswordResetLinkMutationVariables>(SendPasswordResetLinkDocument, options);
      }
export type SendPasswordResetLinkMutationHookResult = ReturnType<typeof useSendPasswordResetLinkMutation>;
export type SendPasswordResetLinkMutationResult = Apollo.MutationResult<SendPasswordResetLinkMutation>;
export type SendPasswordResetLinkMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetLinkMutation, SendPasswordResetLinkMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: AccountInput!) {
  createAccount(input: $input) {
    users {
      id
      roles
      isOnboardingPollComplete
    }
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreatePlainAccountDocument = gql`
    mutation CreatePlainAccount($input: PlainAccountInput!) {
  createPlainAccount(input: $input) {
    id
    name
  }
}
    `;
export type CreatePlainAccountMutationFn = Apollo.MutationFunction<CreatePlainAccountMutation, CreatePlainAccountMutationVariables>;

/**
 * __useCreatePlainAccountMutation__
 *
 * To run a mutation, you first call `useCreatePlainAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlainAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlainAccountMutation, { data, loading, error }] = useCreatePlainAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlainAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlainAccountMutation, CreatePlainAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlainAccountMutation, CreatePlainAccountMutationVariables>(CreatePlainAccountDocument, options);
      }
export type CreatePlainAccountMutationHookResult = ReturnType<typeof useCreatePlainAccountMutation>;
export type CreatePlainAccountMutationResult = Apollo.MutationResult<CreatePlainAccountMutation>;
export type CreatePlainAccountMutationOptions = Apollo.BaseMutationOptions<CreatePlainAccountMutation, CreatePlainAccountMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    id
    activeFrom
    activeTo
    isTrial
    plan {
      id
      pricePerUnit
    }
    active
    seats
    seatsTaken
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const UpdateSubscriptionWithInviteDocument = gql`
    mutation UpdateSubscriptionWithInvite($input: UpdateSubscriptionWithInvite!) {
  updateSubscriptionWithInvite(input: $input) {
    addedUsers
    alreadyExistUsers
  }
}
    `;
export type UpdateSubscriptionWithInviteMutationFn = Apollo.MutationFunction<UpdateSubscriptionWithInviteMutation, UpdateSubscriptionWithInviteMutationVariables>;

/**
 * __useUpdateSubscriptionWithInviteMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionWithInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionWithInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionWithInviteMutation, { data, loading, error }] = useUpdateSubscriptionWithInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionWithInviteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionWithInviteMutation, UpdateSubscriptionWithInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionWithInviteMutation, UpdateSubscriptionWithInviteMutationVariables>(UpdateSubscriptionWithInviteDocument, options);
      }
export type UpdateSubscriptionWithInviteMutationHookResult = ReturnType<typeof useUpdateSubscriptionWithInviteMutation>;
export type UpdateSubscriptionWithInviteMutationResult = Apollo.MutationResult<UpdateSubscriptionWithInviteMutation>;
export type UpdateSubscriptionWithInviteMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionWithInviteMutation, UpdateSubscriptionWithInviteMutationVariables>;
export const UpdateLlunaAccountDocument = gql`
    mutation UpdateLlunaAccount($input: UpdateAccountInput!) {
  updateLlunaAccount(input: $input) {
    id
    integrationCollaboration
    integrationHRIS
    subscriptionId
    actionKey
  }
}
    `;
export type UpdateLlunaAccountMutationFn = Apollo.MutationFunction<UpdateLlunaAccountMutation, UpdateLlunaAccountMutationVariables>;

/**
 * __useUpdateLlunaAccountMutation__
 *
 * To run a mutation, you first call `useUpdateLlunaAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLlunaAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLlunaAccountMutation, { data, loading, error }] = useUpdateLlunaAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLlunaAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLlunaAccountMutation, UpdateLlunaAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLlunaAccountMutation, UpdateLlunaAccountMutationVariables>(UpdateLlunaAccountDocument, options);
      }
export type UpdateLlunaAccountMutationHookResult = ReturnType<typeof useUpdateLlunaAccountMutation>;
export type UpdateLlunaAccountMutationResult = Apollo.MutationResult<UpdateLlunaAccountMutation>;
export type UpdateLlunaAccountMutationOptions = Apollo.BaseMutationOptions<UpdateLlunaAccountMutation, UpdateLlunaAccountMutationVariables>;
export const InviteMemberToAccountDocument = gql`
    mutation InviteMemberToAccount($input: InviteUsersToAccountInput) {
  inviteMemberToAccount(input: $input) {
    addedUsers
    alreadyExistUsers
  }
}
    `;
export type InviteMemberToAccountMutationFn = Apollo.MutationFunction<InviteMemberToAccountMutation, InviteMemberToAccountMutationVariables>;

/**
 * __useInviteMemberToAccountMutation__
 *
 * To run a mutation, you first call `useInviteMemberToAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMemberToAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMemberToAccountMutation, { data, loading, error }] = useInviteMemberToAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMemberToAccountMutation(baseOptions?: Apollo.MutationHookOptions<InviteMemberToAccountMutation, InviteMemberToAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMemberToAccountMutation, InviteMemberToAccountMutationVariables>(InviteMemberToAccountDocument, options);
      }
export type InviteMemberToAccountMutationHookResult = ReturnType<typeof useInviteMemberToAccountMutation>;
export type InviteMemberToAccountMutationResult = Apollo.MutationResult<InviteMemberToAccountMutation>;
export type InviteMemberToAccountMutationOptions = Apollo.BaseMutationOptions<InviteMemberToAccountMutation, InviteMemberToAccountMutationVariables>;
export const CreateSubscriptionForAccountDocument = gql`
    mutation CreateSubscriptionForAccount($input: CreateSubscriptionInput!) {
  createSubscriptionForAccount(input: $input) {
    plus {
      id
      activeFrom
      activeTo
      isTrial
      plan {
        interval
      }
    }
    message
  }
}
    `;
export type CreateSubscriptionForAccountMutationFn = Apollo.MutationFunction<CreateSubscriptionForAccountMutation, CreateSubscriptionForAccountMutationVariables>;

/**
 * __useCreateSubscriptionForAccountMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionForAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionForAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionForAccountMutation, { data, loading, error }] = useCreateSubscriptionForAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionForAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionForAccountMutation, CreateSubscriptionForAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionForAccountMutation, CreateSubscriptionForAccountMutationVariables>(CreateSubscriptionForAccountDocument, options);
      }
export type CreateSubscriptionForAccountMutationHookResult = ReturnType<typeof useCreateSubscriptionForAccountMutation>;
export type CreateSubscriptionForAccountMutationResult = Apollo.MutationResult<CreateSubscriptionForAccountMutation>;
export type CreateSubscriptionForAccountMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionForAccountMutation, CreateSubscriptionForAccountMutationVariables>;
export const CreateContactLlunaDocument = gql`
    mutation CreateContactLluna($input: CreateContactLlunaInput!) {
  createContactLluna(input: $input) {
    email
  }
}
    `;
export type CreateContactLlunaMutationFn = Apollo.MutationFunction<CreateContactLlunaMutation, CreateContactLlunaMutationVariables>;

/**
 * __useCreateContactLlunaMutation__
 *
 * To run a mutation, you first call `useCreateContactLlunaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactLlunaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactLlunaMutation, { data, loading, error }] = useCreateContactLlunaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactLlunaMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactLlunaMutation, CreateContactLlunaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactLlunaMutation, CreateContactLlunaMutationVariables>(CreateContactLlunaDocument, options);
      }
export type CreateContactLlunaMutationHookResult = ReturnType<typeof useCreateContactLlunaMutation>;
export type CreateContactLlunaMutationResult = Apollo.MutationResult<CreateContactLlunaMutation>;
export type CreateContactLlunaMutationOptions = Apollo.BaseMutationOptions<CreateContactLlunaMutation, CreateContactLlunaMutationVariables>;
export const ChangeSubscriptionPlanDocument = gql`
    mutation ChangeSubscriptionPlan($input: ChangePlanInput!) {
  changeSubscriptionPlan(input: $input) {
    message
  }
}
    `;
export type ChangeSubscriptionPlanMutationFn = Apollo.MutationFunction<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;

/**
 * __useChangeSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPlanMutation, { data, loading, error }] = useChangeSubscriptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>(ChangeSubscriptionPlanDocument, options);
      }
export type ChangeSubscriptionPlanMutationHookResult = ReturnType<typeof useChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationResult = Apollo.MutationResult<ChangeSubscriptionPlanMutation>;
export type ChangeSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPlanMutation, ChangeSubscriptionPlanMutationVariables>;
export const ChangeSubscriptionPaymentMethodDocument = gql`
    mutation ChangeSubscriptionPaymentMethod($input: ChangeSubscriptionPaymentMethod!) {
  changeSubscriptionPaymentMethod(input: $input) {
    message
  }
}
    `;
export type ChangeSubscriptionPaymentMethodMutationFn = Apollo.MutationFunction<ChangeSubscriptionPaymentMethodMutation, ChangeSubscriptionPaymentMethodMutationVariables>;

/**
 * __useChangeSubscriptionPaymentMethodMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionPaymentMethodMutation, { data, loading, error }] = useChangeSubscriptionPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSubscriptionPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionPaymentMethodMutation, ChangeSubscriptionPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionPaymentMethodMutation, ChangeSubscriptionPaymentMethodMutationVariables>(ChangeSubscriptionPaymentMethodDocument, options);
      }
export type ChangeSubscriptionPaymentMethodMutationHookResult = ReturnType<typeof useChangeSubscriptionPaymentMethodMutation>;
export type ChangeSubscriptionPaymentMethodMutationResult = Apollo.MutationResult<ChangeSubscriptionPaymentMethodMutation>;
export type ChangeSubscriptionPaymentMethodMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionPaymentMethodMutation, ChangeSubscriptionPaymentMethodMutationVariables>;
export const ChangeTeamSizeDocument = gql`
    mutation ChangeTeamSize($input: UpdateSubscriptionInput!) {
  changeTeamSize(input: $input) {
    seats
    seatsTaken
    stripeSubscriptionId
  }
}
    `;
export type ChangeTeamSizeMutationFn = Apollo.MutationFunction<ChangeTeamSizeMutation, ChangeTeamSizeMutationVariables>;

/**
 * __useChangeTeamSizeMutation__
 *
 * To run a mutation, you first call `useChangeTeamSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeamSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeamSizeMutation, { data, loading, error }] = useChangeTeamSizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTeamSizeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTeamSizeMutation, ChangeTeamSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTeamSizeMutation, ChangeTeamSizeMutationVariables>(ChangeTeamSizeDocument, options);
      }
export type ChangeTeamSizeMutationHookResult = ReturnType<typeof useChangeTeamSizeMutation>;
export type ChangeTeamSizeMutationResult = Apollo.MutationResult<ChangeTeamSizeMutation>;
export type ChangeTeamSizeMutationOptions = Apollo.BaseMutationOptions<ChangeTeamSizeMutation, ChangeTeamSizeMutationVariables>;
export const ChangeSubscriptionBillingDocument = gql`
    mutation ChangeSubscriptionBilling($input: ChangeSubscriptionBillingEmail!) {
  changeSubscriptionBilling(input: $input) {
    message
  }
}
    `;
export type ChangeSubscriptionBillingMutationFn = Apollo.MutationFunction<ChangeSubscriptionBillingMutation, ChangeSubscriptionBillingMutationVariables>;

/**
 * __useChangeSubscriptionBillingMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionBillingMutation, { data, loading, error }] = useChangeSubscriptionBillingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSubscriptionBillingMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionBillingMutation, ChangeSubscriptionBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionBillingMutation, ChangeSubscriptionBillingMutationVariables>(ChangeSubscriptionBillingDocument, options);
      }
export type ChangeSubscriptionBillingMutationHookResult = ReturnType<typeof useChangeSubscriptionBillingMutation>;
export type ChangeSubscriptionBillingMutationResult = Apollo.MutationResult<ChangeSubscriptionBillingMutation>;
export type ChangeSubscriptionBillingMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionBillingMutation, ChangeSubscriptionBillingMutationVariables>;
export const DisconnectSlackIntegrationDocument = gql`
    mutation DisconnectSlackIntegration($accountId: String!) {
  disconnectSlackIntegration(accountId: $accountId) {
    slackWorkspaceId
  }
}
    `;
export type DisconnectSlackIntegrationMutationFn = Apollo.MutationFunction<DisconnectSlackIntegrationMutation, DisconnectSlackIntegrationMutationVariables>;

/**
 * __useDisconnectSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectSlackIntegrationMutation, { data, loading, error }] = useDisconnectSlackIntegrationMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDisconnectSlackIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectSlackIntegrationMutation, DisconnectSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectSlackIntegrationMutation, DisconnectSlackIntegrationMutationVariables>(DisconnectSlackIntegrationDocument, options);
      }
export type DisconnectSlackIntegrationMutationHookResult = ReturnType<typeof useDisconnectSlackIntegrationMutation>;
export type DisconnectSlackIntegrationMutationResult = Apollo.MutationResult<DisconnectSlackIntegrationMutation>;
export type DisconnectSlackIntegrationMutationOptions = Apollo.BaseMutationOptions<DisconnectSlackIntegrationMutation, DisconnectSlackIntegrationMutationVariables>;
export const AccountUserByEmailDocument = gql`
    query AccountUserByEmail($email: String!) {
  accountUserByEmail(email: $email) {
    email
    profile {
      fullName
      surname
      name
    }
    id
    isVerified
    isInvited
  }
}
    `;

/**
 * __useAccountUserByEmailQuery__
 *
 * To run a query within a React component, call `useAccountUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAccountUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>(AccountUserByEmailDocument, options);
      }
export function useAccountUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>(AccountUserByEmailDocument, options);
        }
export type AccountUserByEmailQueryHookResult = ReturnType<typeof useAccountUserByEmailQuery>;
export type AccountUserByEmailLazyQueryHookResult = ReturnType<typeof useAccountUserByEmailLazyQuery>;
export type AccountUserByEmailQueryResult = Apollo.QueryResult<AccountUserByEmailQuery, AccountUserByEmailQueryVariables>;
export const CreateBoardDocument = gql`
    mutation CreateBoard($input: CreateBoardInput!) {
  createBoard(input: $input) {
    id
    name
    editor
  }
}
    `;
export type CreateBoardMutationFn = Apollo.MutationFunction<CreateBoardMutation, CreateBoardMutationVariables>;

/**
 * __useCreateBoardMutation__
 *
 * To run a mutation, you first call `useCreateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoardMutation, { data, loading, error }] = useCreateBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBoardMutation(baseOptions?: Apollo.MutationHookOptions<CreateBoardMutation, CreateBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBoardMutation, CreateBoardMutationVariables>(CreateBoardDocument, options);
      }
export type CreateBoardMutationHookResult = ReturnType<typeof useCreateBoardMutation>;
export type CreateBoardMutationResult = Apollo.MutationResult<CreateBoardMutation>;
export type CreateBoardMutationOptions = Apollo.BaseMutationOptions<CreateBoardMutation, CreateBoardMutationVariables>;
export const UpdateBoardDocument = gql`
    mutation UpdateBoard($input: UpdateBoardInput!) {
  updateBoard(input: $input) {
    id
    name
    editor
  }
}
    `;
export type UpdateBoardMutationFn = Apollo.MutationFunction<UpdateBoardMutation, UpdateBoardMutationVariables>;

/**
 * __useUpdateBoardMutation__
 *
 * To run a mutation, you first call `useUpdateBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoardMutation, { data, loading, error }] = useUpdateBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBoardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoardMutation, UpdateBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBoardMutation, UpdateBoardMutationVariables>(UpdateBoardDocument, options);
      }
export type UpdateBoardMutationHookResult = ReturnType<typeof useUpdateBoardMutation>;
export type UpdateBoardMutationResult = Apollo.MutationResult<UpdateBoardMutation>;
export type UpdateBoardMutationOptions = Apollo.BaseMutationOptions<UpdateBoardMutation, UpdateBoardMutationVariables>;
export const DeleteBoardDocument = gql`
    mutation DeleteBoard($input: DeleteBoardInput!) {
  deleteBoard(input: $input) {
    id
    name
  }
}
    `;
export type DeleteBoardMutationFn = Apollo.MutationFunction<DeleteBoardMutation, DeleteBoardMutationVariables>;

/**
 * __useDeleteBoardMutation__
 *
 * To run a mutation, you first call `useDeleteBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBoardMutation, { data, loading, error }] = useDeleteBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBoardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBoardMutation, DeleteBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBoardMutation, DeleteBoardMutationVariables>(DeleteBoardDocument, options);
      }
export type DeleteBoardMutationHookResult = ReturnType<typeof useDeleteBoardMutation>;
export type DeleteBoardMutationResult = Apollo.MutationResult<DeleteBoardMutation>;
export type DeleteBoardMutationOptions = Apollo.BaseMutationOptions<DeleteBoardMutation, DeleteBoardMutationVariables>;
export const InviteToBoardDocument = gql`
    mutation InviteToBoard($input: [InviteSelectedBoardInput]) {
  inviteToBoard(input: $input) {
    addedMembers {
      id
      userId
      boardId
    }
    alreadyExistMembers {
      id
      userId
      boardId
    }
  }
}
    `;
export type InviteToBoardMutationFn = Apollo.MutationFunction<InviteToBoardMutation, InviteToBoardMutationVariables>;

/**
 * __useInviteToBoardMutation__
 *
 * To run a mutation, you first call `useInviteToBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteToBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteToBoardMutation, { data, loading, error }] = useInviteToBoardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteToBoardMutation(baseOptions?: Apollo.MutationHookOptions<InviteToBoardMutation, InviteToBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteToBoardMutation, InviteToBoardMutationVariables>(InviteToBoardDocument, options);
      }
export type InviteToBoardMutationHookResult = ReturnType<typeof useInviteToBoardMutation>;
export type InviteToBoardMutationResult = Apollo.MutationResult<InviteToBoardMutation>;
export type InviteToBoardMutationOptions = Apollo.BaseMutationOptions<InviteToBoardMutation, InviteToBoardMutationVariables>;
export const SendUpdateRemainderDocument = gql`
    mutation SendUpdateRemainder($input: sendUpdateRemainderInput!) {
  sendUpdateRemainder(input: $input)
}
    `;
export type SendUpdateRemainderMutationFn = Apollo.MutationFunction<SendUpdateRemainderMutation, SendUpdateRemainderMutationVariables>;

/**
 * __useSendUpdateRemainderMutation__
 *
 * To run a mutation, you first call `useSendUpdateRemainderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUpdateRemainderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUpdateRemainderMutation, { data, loading, error }] = useSendUpdateRemainderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendUpdateRemainderMutation(baseOptions?: Apollo.MutationHookOptions<SendUpdateRemainderMutation, SendUpdateRemainderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendUpdateRemainderMutation, SendUpdateRemainderMutationVariables>(SendUpdateRemainderDocument, options);
      }
export type SendUpdateRemainderMutationHookResult = ReturnType<typeof useSendUpdateRemainderMutation>;
export type SendUpdateRemainderMutationResult = Apollo.MutationResult<SendUpdateRemainderMutation>;
export type SendUpdateRemainderMutationOptions = Apollo.BaseMutationOptions<SendUpdateRemainderMutation, SendUpdateRemainderMutationVariables>;
export const BoardsDocument = gql`
    query Boards {
  boards {
    id
    name
    editor
    editorUser {
      id
      email
      readMe {
        quickStartComplete
      }
    }
    boardMember {
      id
      boardId
      userId
      user {
        id
        readMe {
          id
          quickStartComplete
          userId
        }
      }
    }
    boardViewer {
      id
      userId
      boardId
    }
  }
}
    `;

/**
 * __useBoardsQuery__
 *
 * To run a query within a React component, call `useBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBoardsQuery(baseOptions?: Apollo.QueryHookOptions<BoardsQuery, BoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardsQuery, BoardsQueryVariables>(BoardsDocument, options);
      }
export function useBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardsQuery, BoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardsQuery, BoardsQueryVariables>(BoardsDocument, options);
        }
export type BoardsQueryHookResult = ReturnType<typeof useBoardsQuery>;
export type BoardsLazyQueryHookResult = ReturnType<typeof useBoardsLazyQuery>;
export type BoardsQueryResult = Apollo.QueryResult<BoardsQuery, BoardsQueryVariables>;
export const BoardRosterDocument = gql`
    query BoardRoster($boardId: String!) {
  boardRosters(boardId: $boardId) {
    members {
      boardId
      user {
        id
        profile {
          avatar
          fullName
          customSharableString
        }
        readMe {
          responses
          quickStartComplete
        }
      }
    }
    features {
      id
      shortLabel
      choices {
        shortChoiceLabel
        id
      }
      showAsTagTF
      type
      dimension {
        id
      }
    }
    board {
      name
    }
  }
  dimensions {
    id
    meta
    name
    order
  }
}
    `;

/**
 * __useBoardRosterQuery__
 *
 * To run a query within a React component, call `useBoardRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardRosterQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useBoardRosterQuery(baseOptions: Apollo.QueryHookOptions<BoardRosterQuery, BoardRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardRosterQuery, BoardRosterQueryVariables>(BoardRosterDocument, options);
      }
export function useBoardRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardRosterQuery, BoardRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardRosterQuery, BoardRosterQueryVariables>(BoardRosterDocument, options);
        }
export type BoardRosterQueryHookResult = ReturnType<typeof useBoardRosterQuery>;
export type BoardRosterLazyQueryHookResult = ReturnType<typeof useBoardRosterLazyQuery>;
export type BoardRosterQueryResult = Apollo.QueryResult<BoardRosterQuery, BoardRosterQueryVariables>;
export const BoardRostersFeatureRespondentDocument = gql`
    query BoardRostersFeatureRespondent($boardId: String!, $featureId: String!) {
  boardRostersFeatureRespondent(boardId: $boardId, featureId: $featureId) {
    answeredChoices
    choices {
      id
      shortChoiceLabel
    }
    user {
      id
    }
  }
}
    `;

/**
 * __useBoardRostersFeatureRespondentQuery__
 *
 * To run a query within a React component, call `useBoardRostersFeatureRespondentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardRostersFeatureRespondentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardRostersFeatureRespondentQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useBoardRostersFeatureRespondentQuery(baseOptions: Apollo.QueryHookOptions<BoardRostersFeatureRespondentQuery, BoardRostersFeatureRespondentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardRostersFeatureRespondentQuery, BoardRostersFeatureRespondentQueryVariables>(BoardRostersFeatureRespondentDocument, options);
      }
export function useBoardRostersFeatureRespondentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardRostersFeatureRespondentQuery, BoardRostersFeatureRespondentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardRostersFeatureRespondentQuery, BoardRostersFeatureRespondentQueryVariables>(BoardRostersFeatureRespondentDocument, options);
        }
export type BoardRostersFeatureRespondentQueryHookResult = ReturnType<typeof useBoardRostersFeatureRespondentQuery>;
export type BoardRostersFeatureRespondentLazyQueryHookResult = ReturnType<typeof useBoardRostersFeatureRespondentLazyQuery>;
export type BoardRostersFeatureRespondentQueryResult = Apollo.QueryResult<BoardRostersFeatureRespondentQuery, BoardRostersFeatureRespondentQueryVariables>;
export const BoardViewersDocument = gql`
    query BoardViewers($boardId: String!) {
  boardViewers(boardId: $boardId) {
    sectionHeader
    sectionFeatures {
      displayType
      featureAndRespondents {
        feature {
          text
          id
          shortLabel
          showAsTagTF
          definitionTF
          definitionQuestion
          definitionAnswer
          learnMoreTF
          learnMoreLabel
          learnMoreUrl
          purposeTF
          purposeQuestion
          purposeAnswer
        }
        answeredChoices {
          choice {
            id
            shortChoiceLabel
            text
          }
          users {
            id
            profile {
              avatar
              customSharableString
              id
              surname
              name
            }
            readMe {
              responses
              quickStartComplete
            }
            mindSet
          }
        }
        answeredTexts {
          answer
          mindSet
          user {
            id
            profile {
              avatar
              customSharableString
              id
              surname
              name
            }
            readMe {
              responses
              quickStartComplete
            }
            mindSet
          }
        }
        insights {
          insightText
          leadingQuestion
          leadingQuestionTipsLink
          linkText
          type
        }
      }
      insights {
        insightText
        leadingQuestion
        leadingQuestionTipsLink
        linkText
        type
      }
    }
    board {
      name
      boardMember {
        user {
          id
        }
      }
      editorUser {
        id
      }
    }
  }
}
    `;

/**
 * __useBoardViewersQuery__
 *
 * To run a query within a React component, call `useBoardViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardViewersQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useBoardViewersQuery(baseOptions: Apollo.QueryHookOptions<BoardViewersQuery, BoardViewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardViewersQuery, BoardViewersQueryVariables>(BoardViewersDocument, options);
      }
export function useBoardViewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardViewersQuery, BoardViewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardViewersQuery, BoardViewersQueryVariables>(BoardViewersDocument, options);
        }
export type BoardViewersQueryHookResult = ReturnType<typeof useBoardViewersQuery>;
export type BoardViewersLazyQueryHookResult = ReturnType<typeof useBoardViewersLazyQuery>;
export type BoardViewersQueryResult = Apollo.QueryResult<BoardViewersQuery, BoardViewersQueryVariables>;
export const CreateDimensionDocument = gql`
    mutation CreateDimension($input: DimensionInput!) {
  createDimension(data: $input) {
    ...DimensionData
  }
}
    ${DimensionDataFragmentDoc}`;
export type CreateDimensionMutationFn = Apollo.MutationFunction<CreateDimensionMutation, CreateDimensionMutationVariables>;

/**
 * __useCreateDimensionMutation__
 *
 * To run a mutation, you first call `useCreateDimensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDimensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDimensionMutation, { data, loading, error }] = useCreateDimensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDimensionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDimensionMutation, CreateDimensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDimensionMutation, CreateDimensionMutationVariables>(CreateDimensionDocument, options);
      }
export type CreateDimensionMutationHookResult = ReturnType<typeof useCreateDimensionMutation>;
export type CreateDimensionMutationResult = Apollo.MutationResult<CreateDimensionMutation>;
export type CreateDimensionMutationOptions = Apollo.BaseMutationOptions<CreateDimensionMutation, CreateDimensionMutationVariables>;
export const UpdateDimensionDocument = gql`
    mutation UpdateDimension($input: DimensionUpdateInput!) {
  updateDimension(data: $input) {
    ...DimensionData
  }
}
    ${DimensionDataFragmentDoc}`;
export type UpdateDimensionMutationFn = Apollo.MutationFunction<UpdateDimensionMutation, UpdateDimensionMutationVariables>;

/**
 * __useUpdateDimensionMutation__
 *
 * To run a mutation, you first call `useUpdateDimensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDimensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDimensionMutation, { data, loading, error }] = useUpdateDimensionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDimensionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDimensionMutation, UpdateDimensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDimensionMutation, UpdateDimensionMutationVariables>(UpdateDimensionDocument, options);
      }
export type UpdateDimensionMutationHookResult = ReturnType<typeof useUpdateDimensionMutation>;
export type UpdateDimensionMutationResult = Apollo.MutationResult<UpdateDimensionMutation>;
export type UpdateDimensionMutationOptions = Apollo.BaseMutationOptions<UpdateDimensionMutation, UpdateDimensionMutationVariables>;
export const RemoveDimensionDocument = gql`
    mutation RemoveDimension($id: String!) {
  removeDimension(id: $id) {
    id
  }
}
    `;
export type RemoveDimensionMutationFn = Apollo.MutationFunction<RemoveDimensionMutation, RemoveDimensionMutationVariables>;

/**
 * __useRemoveDimensionMutation__
 *
 * To run a mutation, you first call `useRemoveDimensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDimensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDimensionMutation, { data, loading, error }] = useRemoveDimensionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDimensionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDimensionMutation, RemoveDimensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDimensionMutation, RemoveDimensionMutationVariables>(RemoveDimensionDocument, options);
      }
export type RemoveDimensionMutationHookResult = ReturnType<typeof useRemoveDimensionMutation>;
export type RemoveDimensionMutationResult = Apollo.MutationResult<RemoveDimensionMutation>;
export type RemoveDimensionMutationOptions = Apollo.BaseMutationOptions<RemoveDimensionMutation, RemoveDimensionMutationVariables>;
export const DimensionsDocument = gql`
    query Dimensions {
  dimensions {
    ...DimensionData
  }
}
    ${DimensionDataFragmentDoc}`;

/**
 * __useDimensionsQuery__
 *
 * To run a query within a React component, call `useDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDimensionsQuery(baseOptions?: Apollo.QueryHookOptions<DimensionsQuery, DimensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DimensionsQuery, DimensionsQueryVariables>(DimensionsDocument, options);
      }
export function useDimensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DimensionsQuery, DimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DimensionsQuery, DimensionsQueryVariables>(DimensionsDocument, options);
        }
export type DimensionsQueryHookResult = ReturnType<typeof useDimensionsQuery>;
export type DimensionsLazyQueryHookResult = ReturnType<typeof useDimensionsLazyQuery>;
export type DimensionsQueryResult = Apollo.QueryResult<DimensionsQuery, DimensionsQueryVariables>;
export const DimensionDocument = gql`
    query Dimension($id: ID!) {
  dimension(id: $id) {
    ...DimensionData
  }
}
    ${DimensionDataFragmentDoc}`;

/**
 * __useDimensionQuery__
 *
 * To run a query within a React component, call `useDimensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDimensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDimensionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDimensionQuery(baseOptions: Apollo.QueryHookOptions<DimensionQuery, DimensionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DimensionQuery, DimensionQueryVariables>(DimensionDocument, options);
      }
export function useDimensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DimensionQuery, DimensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DimensionQuery, DimensionQueryVariables>(DimensionDocument, options);
        }
export type DimensionQueryHookResult = ReturnType<typeof useDimensionQuery>;
export type DimensionLazyQueryHookResult = ReturnType<typeof useDimensionLazyQuery>;
export type DimensionQueryResult = Apollo.QueryResult<DimensionQuery, DimensionQueryVariables>;
export const CreateFeatureDocument = gql`
    mutation CreateFeature($data: FeatureCreateInput!) {
  createFeature(data: $data) {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;
export type CreateFeatureMutationFn = Apollo.MutationFunction<CreateFeatureMutation, CreateFeatureMutationVariables>;

/**
 * __useCreateFeatureMutation__
 *
 * To run a mutation, you first call `useCreateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureMutation, { data, loading, error }] = useCreateFeatureMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureMutation, CreateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureMutation, CreateFeatureMutationVariables>(CreateFeatureDocument, options);
      }
export type CreateFeatureMutationHookResult = ReturnType<typeof useCreateFeatureMutation>;
export type CreateFeatureMutationResult = Apollo.MutationResult<CreateFeatureMutation>;
export type CreateFeatureMutationOptions = Apollo.BaseMutationOptions<CreateFeatureMutation, CreateFeatureMutationVariables>;
export const RemoveFeatureDocument = gql`
    mutation RemoveFeature($id: String!) {
  removeFeature(id: $id) {
    id
    text
    type
  }
}
    `;
export type RemoveFeatureMutationFn = Apollo.MutationFunction<RemoveFeatureMutation, RemoveFeatureMutationVariables>;

/**
 * __useRemoveFeatureMutation__
 *
 * To run a mutation, you first call `useRemoveFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFeatureMutation, { data, loading, error }] = useRemoveFeatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFeatureMutation, RemoveFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFeatureMutation, RemoveFeatureMutationVariables>(RemoveFeatureDocument, options);
      }
export type RemoveFeatureMutationHookResult = ReturnType<typeof useRemoveFeatureMutation>;
export type RemoveFeatureMutationResult = Apollo.MutationResult<RemoveFeatureMutation>;
export type RemoveFeatureMutationOptions = Apollo.BaseMutationOptions<RemoveFeatureMutation, RemoveFeatureMutationVariables>;
export const UpdateFeatureDocument = gql`
    mutation UpdateFeature($data: FeatureUpdateInput!) {
  updateFeature(data: $data) {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;
export type UpdateFeatureMutationFn = Apollo.MutationFunction<UpdateFeatureMutation, UpdateFeatureMutationVariables>;

/**
 * __useUpdateFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureMutation, { data, loading, error }] = useUpdateFeatureMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureMutation, UpdateFeatureMutationVariables>(UpdateFeatureDocument, options);
      }
export type UpdateFeatureMutationHookResult = ReturnType<typeof useUpdateFeatureMutation>;
export type UpdateFeatureMutationResult = Apollo.MutationResult<UpdateFeatureMutation>;
export type UpdateFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>;
export const FeaturesDocument = gql`
    query Features($input: TableDataInput!) {
  features(input: $input) {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions: Apollo.QueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<FeaturesQuery, FeaturesQueryVariables>;
export const FeatureDocument = gql`
    query Feature($featureId: ID!) {
  feature(id: $featureId) {
    ...FeatureData
  }
}
    ${FeatureDataFragmentDoc}`;

/**
 * __useFeatureQuery__
 *
 * To run a query within a React component, call `useFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureQuery({
 *   variables: {
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useFeatureQuery(baseOptions: Apollo.QueryHookOptions<FeatureQuery, FeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureQuery, FeatureQueryVariables>(FeatureDocument, options);
      }
export function useFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureQuery, FeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureQuery, FeatureQueryVariables>(FeatureDocument, options);
        }
export type FeatureQueryHookResult = ReturnType<typeof useFeatureQuery>;
export type FeatureLazyQueryHookResult = ReturnType<typeof useFeatureLazyQuery>;
export type FeatureQueryResult = Apollo.QueryResult<FeatureQuery, FeatureQueryVariables>;
export const AccountsDocument = gql`
    query Accounts($query: String) {
  accounts(query: $query) {
    id
    name
    integrationCollaboration
    integrationHRIS
    isStripeCustomer
    subscriptionId
    users {
      email
      profile {
        fullName
      }
    }
    subscriptions {
      stripeSubscriptionId
      id
    }
  }
}
    `;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export const SubmitAuthCodeDocument = gql`
    mutation SubmitAuthCode($input: FinchIntegrationInput!) {
  submitAuthCode(input: $input) {
    status
    message
  }
}
    `;
export type SubmitAuthCodeMutationFn = Apollo.MutationFunction<SubmitAuthCodeMutation, SubmitAuthCodeMutationVariables>;

/**
 * __useSubmitAuthCodeMutation__
 *
 * To run a mutation, you first call `useSubmitAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAuthCodeMutation, { data, loading, error }] = useSubmitAuthCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAuthCodeMutation, SubmitAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAuthCodeMutation, SubmitAuthCodeMutationVariables>(SubmitAuthCodeDocument, options);
      }
export type SubmitAuthCodeMutationHookResult = ReturnType<typeof useSubmitAuthCodeMutation>;
export type SubmitAuthCodeMutationResult = Apollo.MutationResult<SubmitAuthCodeMutation>;
export type SubmitAuthCodeMutationOptions = Apollo.BaseMutationOptions<SubmitAuthCodeMutation, SubmitAuthCodeMutationVariables>;
export const IntegrationsDocument = gql`
    query Integrations {
  integrations {
    id
    name
    status
    accountIntegrations {
      id
      accountId
      accessToken
      status
      atsName
    }
  }
}
    `;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const CheckInvitationDocument = gql`
    query CheckInvitation($invitationCode: String!) {
  checkInvitation(invitationCode: $invitationCode) {
    status
    user {
      email
      profile {
        name
        surname
      }
    }
  }
}
    `;

/**
 * __useCheckInvitationQuery__
 *
 * To run a query within a React component, call `useCheckInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInvitationQuery({
 *   variables: {
 *      invitationCode: // value for 'invitationCode'
 *   },
 * });
 */
export function useCheckInvitationQuery(baseOptions: Apollo.QueryHookOptions<CheckInvitationQuery, CheckInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, options);
      }
export function useCheckInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckInvitationQuery, CheckInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckInvitationQuery, CheckInvitationQueryVariables>(CheckInvitationDocument, options);
        }
export type CheckInvitationQueryHookResult = ReturnType<typeof useCheckInvitationQuery>;
export type CheckInvitationLazyQueryHookResult = ReturnType<typeof useCheckInvitationLazyQuery>;
export type CheckInvitationQueryResult = Apollo.QueryResult<CheckInvitationQuery, CheckInvitationQueryVariables>;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans {
    id
    isActive
    liveStripeProductId
    meta
    name
    testStripeProductId
    prices {
      id
      testStripePriceId
      liveStripePriceId
      isActive
      pricePerUnit
      interval
      meta
      name
    }
  }
}
    `;

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
      }
export function useSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export type SubscriptionPlansQueryHookResult = ReturnType<typeof useSubscriptionPlansQuery>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansLazyQuery>;
export type SubscriptionPlansQueryResult = Apollo.QueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export const GetStripeCouponDocument = gql`
    query GetStripeCoupon($code: String!) {
  getStripeCoupon(code: $code) {
    active
    code
    coupon
    id
    object
  }
}
    `;

/**
 * __useGetStripeCouponQuery__
 *
 * To run a query within a React component, call `useGetStripeCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetStripeCouponQuery(baseOptions: Apollo.QueryHookOptions<GetStripeCouponQuery, GetStripeCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeCouponQuery, GetStripeCouponQueryVariables>(GetStripeCouponDocument, options);
      }
export function useGetStripeCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeCouponQuery, GetStripeCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeCouponQuery, GetStripeCouponQueryVariables>(GetStripeCouponDocument, options);
        }
export type GetStripeCouponQueryHookResult = ReturnType<typeof useGetStripeCouponQuery>;
export type GetStripeCouponLazyQueryHookResult = ReturnType<typeof useGetStripeCouponLazyQuery>;
export type GetStripeCouponQueryResult = Apollo.QueryResult<GetStripeCouponQuery, GetStripeCouponQueryVariables>;
export const ReadMeSharableInfoDocument = gql`
    query ReadMeSharableInfo($input: SharedReadMeViewInput!) {
  readMeSharableInfo(input: $input) {
    responses
    user {
      profile {
        avatar
        id
        name
        surname
        addresses {
          locality
          lat
          lng
        }
        hireDate
        jobTitle
        officeLocation
        timeZone
        phoneNumber
        industry
        objects
        subjects
        companyName
        jobRole
        possessives
      }
    }
    aboutMe
  }
}
    `;

/**
 * __useReadMeSharableInfoQuery__
 *
 * To run a query within a React component, call `useReadMeSharableInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMeSharableInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMeSharableInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadMeSharableInfoQuery(baseOptions: Apollo.QueryHookOptions<ReadMeSharableInfoQuery, ReadMeSharableInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMeSharableInfoQuery, ReadMeSharableInfoQueryVariables>(ReadMeSharableInfoDocument, options);
      }
export function useReadMeSharableInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMeSharableInfoQuery, ReadMeSharableInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMeSharableInfoQuery, ReadMeSharableInfoQueryVariables>(ReadMeSharableInfoDocument, options);
        }
export type ReadMeSharableInfoQueryHookResult = ReturnType<typeof useReadMeSharableInfoQuery>;
export type ReadMeSharableInfoLazyQueryHookResult = ReturnType<typeof useReadMeSharableInfoLazyQuery>;
export type ReadMeSharableInfoQueryResult = Apollo.QueryResult<ReadMeSharableInfoQuery, ReadMeSharableInfoQueryVariables>;
export const ProfileUpdateDocument = gql`
    mutation ProfileUpdate($input: ProfileUpdateInput!) {
  updateProfile(input: $input) {
    ...ProfileData
  }
}
    ${ProfileDataFragmentDoc}`;
export type ProfileUpdateMutationFn = Apollo.MutationFunction<ProfileUpdateMutation, ProfileUpdateMutationVariables>;

/**
 * __useProfileUpdateMutation__
 *
 * To run a mutation, you first call `useProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateMutation, { data, loading, error }] = useProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateMutation, ProfileUpdateMutationVariables>(ProfileUpdateDocument, options);
      }
export type ProfileUpdateMutationHookResult = ReturnType<typeof useProfileUpdateMutation>;
export type ProfileUpdateMutationResult = Apollo.MutationResult<ProfileUpdateMutation>;
export type ProfileUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>;
export const UpdateProfileAvatarDocument = gql`
    mutation UpdateProfileAvatar($src: String!) {
  updateProfileAvatar(src: $src) {
    avatar
    id
  }
}
    `;
export type UpdateProfileAvatarMutationFn = Apollo.MutationFunction<UpdateProfileAvatarMutation, UpdateProfileAvatarMutationVariables>;

/**
 * __useUpdateProfileAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateProfileAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileAvatarMutation, { data, loading, error }] = useUpdateProfileAvatarMutation({
 *   variables: {
 *      src: // value for 'src'
 *   },
 * });
 */
export function useUpdateProfileAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileAvatarMutation, UpdateProfileAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileAvatarMutation, UpdateProfileAvatarMutationVariables>(UpdateProfileAvatarDocument, options);
      }
export type UpdateProfileAvatarMutationHookResult = ReturnType<typeof useUpdateProfileAvatarMutation>;
export type UpdateProfileAvatarMutationResult = Apollo.MutationResult<UpdateProfileAvatarMutation>;
export type UpdateProfileAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateProfileAvatarMutation, UpdateProfileAvatarMutationVariables>;
export const UpdateSignupProfileDocument = gql`
    mutation UpdateSignupProfile($input: SignupProfileInput!) {
  updateSignupProfile(input: $input) {
    id
    name
    surname
    fullName
    companyName
    industry
    jobTitle
    jobRole
    timeZone
  }
}
    `;
export type UpdateSignupProfileMutationFn = Apollo.MutationFunction<UpdateSignupProfileMutation, UpdateSignupProfileMutationVariables>;

/**
 * __useUpdateSignupProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSignupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignupProfileMutation, { data, loading, error }] = useUpdateSignupProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignupProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignupProfileMutation, UpdateSignupProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignupProfileMutation, UpdateSignupProfileMutationVariables>(UpdateSignupProfileDocument, options);
      }
export type UpdateSignupProfileMutationHookResult = ReturnType<typeof useUpdateSignupProfileMutation>;
export type UpdateSignupProfileMutationResult = Apollo.MutationResult<UpdateSignupProfileMutation>;
export type UpdateSignupProfileMutationOptions = Apollo.BaseMutationOptions<UpdateSignupProfileMutation, UpdateSignupProfileMutationVariables>;
export const CreateReadmeDocument = gql`
    mutation CreateReadme($input: CreateReadmeInput!) {
  createReadme(input: $input) {
    id
    quickStartComplete
    aboutMe
    responses
    userId
  }
}
    `;
export type CreateReadmeMutationFn = Apollo.MutationFunction<CreateReadmeMutation, CreateReadmeMutationVariables>;

/**
 * __useCreateReadmeMutation__
 *
 * To run a mutation, you first call `useCreateReadmeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReadmeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReadmeMutation, { data, loading, error }] = useCreateReadmeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReadmeMutation(baseOptions?: Apollo.MutationHookOptions<CreateReadmeMutation, CreateReadmeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReadmeMutation, CreateReadmeMutationVariables>(CreateReadmeDocument, options);
      }
export type CreateReadmeMutationHookResult = ReturnType<typeof useCreateReadmeMutation>;
export type CreateReadmeMutationResult = Apollo.MutationResult<CreateReadmeMutation>;
export type CreateReadmeMutationOptions = Apollo.BaseMutationOptions<CreateReadmeMutation, CreateReadmeMutationVariables>;
export const UpdateReadmeDocument = gql`
    mutation UpdateReadme($input: UpdateReadmeInput!) {
  updateReadme(input: $input) {
    id
    aboutMe
    responses
    userId
    quickStartComplete
  }
}
    `;
export type UpdateReadmeMutationFn = Apollo.MutationFunction<UpdateReadmeMutation, UpdateReadmeMutationVariables>;

/**
 * __useUpdateReadmeMutation__
 *
 * To run a mutation, you first call `useUpdateReadmeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReadmeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReadmeMutation, { data, loading, error }] = useUpdateReadmeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReadmeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReadmeMutation, UpdateReadmeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReadmeMutation, UpdateReadmeMutationVariables>(UpdateReadmeDocument, options);
      }
export type UpdateReadmeMutationHookResult = ReturnType<typeof useUpdateReadmeMutation>;
export type UpdateReadmeMutationResult = Apollo.MutationResult<UpdateReadmeMutation>;
export type UpdateReadmeMutationOptions = Apollo.BaseMutationOptions<UpdateReadmeMutation, UpdateReadmeMutationVariables>;
export const ShareReadmeDocument = gql`
    mutation ShareReadme($input: ShareReadMeInput!) {
  shareReadme(input: $input) {
    id
  }
}
    `;
export type ShareReadmeMutationFn = Apollo.MutationFunction<ShareReadmeMutation, ShareReadmeMutationVariables>;

/**
 * __useShareReadmeMutation__
 *
 * To run a mutation, you first call `useShareReadmeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareReadmeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareReadmeMutation, { data, loading, error }] = useShareReadmeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareReadmeMutation(baseOptions?: Apollo.MutationHookOptions<ShareReadmeMutation, ShareReadmeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareReadmeMutation, ShareReadmeMutationVariables>(ShareReadmeDocument, options);
      }
export type ShareReadmeMutationHookResult = ReturnType<typeof useShareReadmeMutation>;
export type ShareReadmeMutationResult = Apollo.MutationResult<ShareReadmeMutation>;
export type ShareReadmeMutationOptions = Apollo.BaseMutationOptions<ShareReadmeMutation, ShareReadmeMutationVariables>;
export const GetReadMeDocument = gql`
    query getReadMe($userId: String!) {
  readMe(userId: $userId) {
    id
    aboutMe
    quickStartComplete
    responses
    userId
    views
    updatedAt
  }
}
    `;

/**
 * __useGetReadMeQuery__
 *
 * To run a query within a React component, call `useGetReadMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReadMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReadMeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReadMeQuery(baseOptions: Apollo.QueryHookOptions<GetReadMeQuery, GetReadMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReadMeQuery, GetReadMeQueryVariables>(GetReadMeDocument, options);
      }
export function useGetReadMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReadMeQuery, GetReadMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReadMeQuery, GetReadMeQueryVariables>(GetReadMeDocument, options);
        }
export type GetReadMeQueryHookResult = ReturnType<typeof useGetReadMeQuery>;
export type GetReadMeLazyQueryHookResult = ReturnType<typeof useGetReadMeLazyQuery>;
export type GetReadMeQueryResult = Apollo.QueryResult<GetReadMeQuery, GetReadMeQueryVariables>;
export const ReadMeForShareDocument = gql`
    query ReadMeForShare {
  readMeForShare {
    id
    customString
  }
}
    `;

/**
 * __useReadMeForShareQuery__
 *
 * To run a query within a React component, call `useReadMeForShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMeForShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMeForShareQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadMeForShareQuery(baseOptions?: Apollo.QueryHookOptions<ReadMeForShareQuery, ReadMeForShareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMeForShareQuery, ReadMeForShareQueryVariables>(ReadMeForShareDocument, options);
      }
export function useReadMeForShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMeForShareQuery, ReadMeForShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMeForShareQuery, ReadMeForShareQueryVariables>(ReadMeForShareDocument, options);
        }
export type ReadMeForShareQueryHookResult = ReturnType<typeof useReadMeForShareQuery>;
export type ReadMeForShareLazyQueryHookResult = ReturnType<typeof useReadMeForShareLazyQuery>;
export type ReadMeForShareQueryResult = Apollo.QueryResult<ReadMeForShareQuery, ReadMeForShareQueryVariables>;
export const StripeSetupPaymentIntentDocument = gql`
    mutation StripeSetupPaymentIntent {
  stripeSetupPaymentIntent {
    clientSecret
  }
}
    `;
export type StripeSetupPaymentIntentMutationFn = Apollo.MutationFunction<StripeSetupPaymentIntentMutation, StripeSetupPaymentIntentMutationVariables>;

/**
 * __useStripeSetupPaymentIntentMutation__
 *
 * To run a mutation, you first call `useStripeSetupPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSetupPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSetupPaymentIntentMutation, { data, loading, error }] = useStripeSetupPaymentIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStripeSetupPaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<StripeSetupPaymentIntentMutation, StripeSetupPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSetupPaymentIntentMutation, StripeSetupPaymentIntentMutationVariables>(StripeSetupPaymentIntentDocument, options);
      }
export type StripeSetupPaymentIntentMutationHookResult = ReturnType<typeof useStripeSetupPaymentIntentMutation>;
export type StripeSetupPaymentIntentMutationResult = Apollo.MutationResult<StripeSetupPaymentIntentMutation>;
export type StripeSetupPaymentIntentMutationOptions = Apollo.BaseMutationOptions<StripeSetupPaymentIntentMutation, StripeSetupPaymentIntentMutationVariables>;
export const StripeCreateCustomerPortalSessionDocument = gql`
    mutation StripeCreateCustomerPortalSession {
  stripeCreateCustomerPortalSession
}
    `;
export type StripeCreateCustomerPortalSessionMutationFn = Apollo.MutationFunction<StripeCreateCustomerPortalSessionMutation, StripeCreateCustomerPortalSessionMutationVariables>;

/**
 * __useStripeCreateCustomerPortalSessionMutation__
 *
 * To run a mutation, you first call `useStripeCreateCustomerPortalSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreateCustomerPortalSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreateCustomerPortalSessionMutation, { data, loading, error }] = useStripeCreateCustomerPortalSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStripeCreateCustomerPortalSessionMutation(baseOptions?: Apollo.MutationHookOptions<StripeCreateCustomerPortalSessionMutation, StripeCreateCustomerPortalSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCreateCustomerPortalSessionMutation, StripeCreateCustomerPortalSessionMutationVariables>(StripeCreateCustomerPortalSessionDocument, options);
      }
export type StripeCreateCustomerPortalSessionMutationHookResult = ReturnType<typeof useStripeCreateCustomerPortalSessionMutation>;
export type StripeCreateCustomerPortalSessionMutationResult = Apollo.MutationResult<StripeCreateCustomerPortalSessionMutation>;
export type StripeCreateCustomerPortalSessionMutationOptions = Apollo.BaseMutationOptions<StripeCreateCustomerPortalSessionMutation, StripeCreateCustomerPortalSessionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription {
  cancelSubscription {
    id
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CustomerPaymentMethodsDocument = gql`
    query CustomerPaymentMethods {
  customerPaymentMethods {
    expireYear
    expiryMonth
    last4Digits
    name
    paymentMethodId
    isDefaultPaymentMethod
    type
  }
}
    `;

/**
 * __useCustomerPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useCustomerPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, options);
      }
export function useCustomerPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, options);
        }
export type CustomerPaymentMethodsQueryHookResult = ReturnType<typeof useCustomerPaymentMethodsQuery>;
export type CustomerPaymentMethodsLazyQueryHookResult = ReturnType<typeof useCustomerPaymentMethodsLazyQuery>;
export type CustomerPaymentMethodsQueryResult = Apollo.QueryResult<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>;
export const CreateTeamMemberDocument = gql`
    mutation CreateTeamMember($input: CreateUserInput!) {
  createTeamMember(input: $input) {
    ...AccountUserData
  }
}
    ${AccountUserDataFragmentDoc}`;
export type CreateTeamMemberMutationFn = Apollo.MutationFunction<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;

/**
 * __useCreateTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberMutation, { data, loading, error }] = useCreateTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>(CreateTeamMemberDocument, options);
      }
export type CreateTeamMemberMutationHookResult = ReturnType<typeof useCreateTeamMemberMutation>;
export type CreateTeamMemberMutationResult = Apollo.MutationResult<CreateTeamMemberMutation>;
export type CreateTeamMemberMutationOptions = Apollo.BaseMutationOptions<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreatePlainUserInput!) {
  createUser(input: $input) {
    ...AccountUserData
  }
}
    ${AccountUserDataFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateCurrentUserPollDocument = gql`
    mutation UpdateCurrentUserPoll($pollResult: Json) {
  updateCurrentUserPoll(pollResult: $pollResult) {
    id
    meta
    isOnboardingPollComplete
  }
}
    `;
export type UpdateCurrentUserPollMutationFn = Apollo.MutationFunction<UpdateCurrentUserPollMutation, UpdateCurrentUserPollMutationVariables>;

/**
 * __useUpdateCurrentUserPollMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserPollMutation, { data, loading, error }] = useUpdateCurrentUserPollMutation({
 *   variables: {
 *      pollResult: // value for 'pollResult'
 *   },
 * });
 */
export function useUpdateCurrentUserPollMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserPollMutation, UpdateCurrentUserPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserPollMutation, UpdateCurrentUserPollMutationVariables>(UpdateCurrentUserPollDocument, options);
      }
export type UpdateCurrentUserPollMutationHookResult = ReturnType<typeof useUpdateCurrentUserPollMutation>;
export type UpdateCurrentUserPollMutationResult = Apollo.MutationResult<UpdateCurrentUserPollMutation>;
export type UpdateCurrentUserPollMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserPollMutation, UpdateCurrentUserPollMutationVariables>;
export const ToggleUsersDocument = gql`
    mutation ToggleUsers($userIds: [ID!]!, $isEnabled: Boolean!) {
  toggleUsers(userIds: $userIds, isEnabled: $isEnabled)
}
    `;
export type ToggleUsersMutationFn = Apollo.MutationFunction<ToggleUsersMutation, ToggleUsersMutationVariables>;

/**
 * __useToggleUsersMutation__
 *
 * To run a mutation, you first call `useToggleUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUsersMutation, { data, loading, error }] = useToggleUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useToggleUsersMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUsersMutation, ToggleUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUsersMutation, ToggleUsersMutationVariables>(ToggleUsersDocument, options);
      }
export type ToggleUsersMutationHookResult = ReturnType<typeof useToggleUsersMutation>;
export type ToggleUsersMutationResult = Apollo.MutationResult<ToggleUsersMutation>;
export type ToggleUsersMutationOptions = Apollo.BaseMutationOptions<ToggleUsersMutation, ToggleUsersMutationVariables>;
export const UpdateLastLoggedInDocument = gql`
    mutation UpdateLastLoggedIn {
  updateLastLoggedIn {
    id
    lastLoginAt
  }
}
    `;
export type UpdateLastLoggedInMutationFn = Apollo.MutationFunction<UpdateLastLoggedInMutation, UpdateLastLoggedInMutationVariables>;

/**
 * __useUpdateLastLoggedInMutation__
 *
 * To run a mutation, you first call `useUpdateLastLoggedInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastLoggedInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastLoggedInMutation, { data, loading, error }] = useUpdateLastLoggedInMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastLoggedInMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastLoggedInMutation, UpdateLastLoggedInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastLoggedInMutation, UpdateLastLoggedInMutationVariables>(UpdateLastLoggedInDocument, options);
      }
export type UpdateLastLoggedInMutationHookResult = ReturnType<typeof useUpdateLastLoggedInMutation>;
export type UpdateLastLoggedInMutationResult = Apollo.MutationResult<UpdateLastLoggedInMutation>;
export type UpdateLastLoggedInMutationOptions = Apollo.BaseMutationOptions<UpdateLastLoggedInMutation, UpdateLastLoggedInMutationVariables>;
export const MarkNotificationReaderDocument = gql`
    mutation MarkNotificationReader($input: CreateNotificationReaderInput!) {
  markNotificationReader(input: $input) {
    count
  }
}
    `;
export type MarkNotificationReaderMutationFn = Apollo.MutationFunction<MarkNotificationReaderMutation, MarkNotificationReaderMutationVariables>;

/**
 * __useMarkNotificationReaderMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReaderMutation, { data, loading, error }] = useMarkNotificationReaderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationReaderMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationReaderMutation, MarkNotificationReaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationReaderMutation, MarkNotificationReaderMutationVariables>(MarkNotificationReaderDocument, options);
      }
export type MarkNotificationReaderMutationHookResult = ReturnType<typeof useMarkNotificationReaderMutation>;
export type MarkNotificationReaderMutationResult = Apollo.MutationResult<MarkNotificationReaderMutation>;
export type MarkNotificationReaderMutationOptions = Apollo.BaseMutationOptions<MarkNotificationReaderMutation, MarkNotificationReaderMutationVariables>;
export const UpdateSignUpDocument = gql`
    mutation UpdateSignUp($input: UpdateUserInput) {
  updateUserSignup(input: $input) {
    email
    isVerified
  }
}
    `;
export type UpdateSignUpMutationFn = Apollo.MutationFunction<UpdateSignUpMutation, UpdateSignUpMutationVariables>;

/**
 * __useUpdateSignUpMutation__
 *
 * To run a mutation, you first call `useUpdateSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignUpMutation, { data, loading, error }] = useUpdateSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignUpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSignUpMutation, UpdateSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSignUpMutation, UpdateSignUpMutationVariables>(UpdateSignUpDocument, options);
      }
export type UpdateSignUpMutationHookResult = ReturnType<typeof useUpdateSignUpMutation>;
export type UpdateSignUpMutationResult = Apollo.MutationResult<UpdateSignUpMutation>;
export type UpdateSignUpMutationOptions = Apollo.BaseMutationOptions<UpdateSignUpMutation, UpdateSignUpMutationVariables>;
export const VerifyUserDocument = gql`
    mutation verifyUser($input: UserEmailInput) {
  forcefullyVerifyUser(input: $input) {
    msg
  }
}
    `;
export type VerifyUserMutationFn = Apollo.MutationFunction<VerifyUserMutation, VerifyUserMutationVariables>;

/**
 * __useVerifyUserMutation__
 *
 * To run a mutation, you first call `useVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserMutation, { data, loading, error }] = useVerifyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserMutation, VerifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(VerifyUserDocument, options);
      }
export type VerifyUserMutationHookResult = ReturnType<typeof useVerifyUserMutation>;
export type VerifyUserMutationResult = Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<VerifyUserMutation, VerifyUserMutationVariables>;
export const SyncFirebaseUserDocument = gql`
    mutation syncFirebaseUser($email: String!, $sso: Boolean!) {
  syncFirebaseUser(email: $email, sso: $sso) {
    isVerified
  }
}
    `;
export type SyncFirebaseUserMutationFn = Apollo.MutationFunction<SyncFirebaseUserMutation, SyncFirebaseUserMutationVariables>;

/**
 * __useSyncFirebaseUserMutation__
 *
 * To run a mutation, you first call `useSyncFirebaseUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncFirebaseUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncFirebaseUserMutation, { data, loading, error }] = useSyncFirebaseUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      sso: // value for 'sso'
 *   },
 * });
 */
export function useSyncFirebaseUserMutation(baseOptions?: Apollo.MutationHookOptions<SyncFirebaseUserMutation, SyncFirebaseUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncFirebaseUserMutation, SyncFirebaseUserMutationVariables>(SyncFirebaseUserDocument, options);
      }
export type SyncFirebaseUserMutationHookResult = ReturnType<typeof useSyncFirebaseUserMutation>;
export type SyncFirebaseUserMutationResult = Apollo.MutationResult<SyncFirebaseUserMutation>;
export type SyncFirebaseUserMutationOptions = Apollo.BaseMutationOptions<SyncFirebaseUserMutation, SyncFirebaseUserMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    roles
    createdAt
    isVerified
    isOnboardingPollComplete
    onFreePlan
    additionalPermissions
    profile {
      avatar
      name
      surname
      fullName
      customSharableString
    }
    account {
      name
      id
      selectedPlanType
      isStripeCustomer
      subscriptions {
        ...SubscriptionData
      }
      integrationHRIS
      integrationCollaboration
      subscriptionId
    }
    slackWorkspace {
      team_id
      team_name
    }
    intercomData {
      accountBoardCount
      accountUserCount
      boardEditor
      boardMembership
      onFreePlan
      quickStartComplete
    }
    activity
    isInvited
  }
}
    ${SubscriptionDataFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CurrentAccountUsersDocument = gql`
    query CurrentAccountUsers($input: TableDataInput!) {
  currentAccountUsers(input: $input) {
    cursor
    total
    users {
      ...AccountUserData
    }
  }
}
    ${AccountUserDataFragmentDoc}`;

/**
 * __useCurrentAccountUsersQuery__
 *
 * To run a query within a React component, call `useCurrentAccountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCurrentAccountUsersQuery(baseOptions: Apollo.QueryHookOptions<CurrentAccountUsersQuery, CurrentAccountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountUsersQuery, CurrentAccountUsersQueryVariables>(CurrentAccountUsersDocument, options);
      }
export function useCurrentAccountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountUsersQuery, CurrentAccountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountUsersQuery, CurrentAccountUsersQueryVariables>(CurrentAccountUsersDocument, options);
        }
export type CurrentAccountUsersQueryHookResult = ReturnType<typeof useCurrentAccountUsersQuery>;
export type CurrentAccountUsersLazyQueryHookResult = ReturnType<typeof useCurrentAccountUsersLazyQuery>;
export type CurrentAccountUsersQueryResult = Apollo.QueryResult<CurrentAccountUsersQuery, CurrentAccountUsersQueryVariables>;
export const AccountUsersDocument = gql`
    query AccountUsers($input: TableDataInput!, $accountId: String!) {
  accountUsers(input: $input, accountId: $accountId) {
    cursor
    total
    users {
      ...AccountUserData
    }
  }
}
    ${AccountUserDataFragmentDoc}`;

/**
 * __useAccountUsersQuery__
 *
 * To run a query within a React component, call `useAccountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountUsersQuery(baseOptions: Apollo.QueryHookOptions<AccountUsersQuery, AccountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUsersQuery, AccountUsersQueryVariables>(AccountUsersDocument, options);
      }
export function useAccountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUsersQuery, AccountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUsersQuery, AccountUsersQueryVariables>(AccountUsersDocument, options);
        }
export type AccountUsersQueryHookResult = ReturnType<typeof useAccountUsersQuery>;
export type AccountUsersLazyQueryHookResult = ReturnType<typeof useAccountUsersLazyQuery>;
export type AccountUsersQueryResult = Apollo.QueryResult<AccountUsersQuery, AccountUsersQueryVariables>;
export const AccountUserDocument = gql`
    query AccountUser($id: String!) {
  accountUser(id: $id) {
    ...AccountUserData
  }
}
    ${AccountUserDataFragmentDoc}`;

/**
 * __useAccountUserQuery__
 *
 * To run a query within a React component, call `useAccountUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountUserQuery(baseOptions: Apollo.QueryHookOptions<AccountUserQuery, AccountUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUserQuery, AccountUserQueryVariables>(AccountUserDocument, options);
      }
export function useAccountUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUserQuery, AccountUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUserQuery, AccountUserQueryVariables>(AccountUserDocument, options);
        }
export type AccountUserQueryHookResult = ReturnType<typeof useAccountUserQuery>;
export type AccountUserLazyQueryHookResult = ReturnType<typeof useAccountUserLazyQuery>;
export type AccountUserQueryResult = Apollo.QueryResult<AccountUserQuery, AccountUserQueryVariables>;
export const DashboardTeamMemberDocument = gql`
    query DashboardTeamMember {
  me {
    ...MeData
  }
}
    ${MeDataFragmentDoc}`;

/**
 * __useDashboardTeamMemberQuery__
 *
 * To run a query within a React component, call `useDashboardTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardTeamMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardTeamMemberQuery(baseOptions?: Apollo.QueryHookOptions<DashboardTeamMemberQuery, DashboardTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardTeamMemberQuery, DashboardTeamMemberQueryVariables>(DashboardTeamMemberDocument, options);
      }
export function useDashboardTeamMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardTeamMemberQuery, DashboardTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardTeamMemberQuery, DashboardTeamMemberQueryVariables>(DashboardTeamMemberDocument, options);
        }
export type DashboardTeamMemberQueryHookResult = ReturnType<typeof useDashboardTeamMemberQuery>;
export type DashboardTeamMemberLazyQueryHookResult = ReturnType<typeof useDashboardTeamMemberLazyQuery>;
export type DashboardTeamMemberQueryResult = Apollo.QueryResult<DashboardTeamMemberQuery, DashboardTeamMemberQueryVariables>;
export const UserScopesDocument = gql`
    query UserScopes {
  userScopes {
    accountId
    jobTitles
    officeLocation
    functions
  }
}
    `;

/**
 * __useUserScopesQuery__
 *
 * To run a query within a React component, call `useUserScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserScopesQuery(baseOptions?: Apollo.QueryHookOptions<UserScopesQuery, UserScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserScopesQuery, UserScopesQueryVariables>(UserScopesDocument, options);
      }
export function useUserScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserScopesQuery, UserScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserScopesQuery, UserScopesQueryVariables>(UserScopesDocument, options);
        }
export type UserScopesQueryHookResult = ReturnType<typeof useUserScopesQuery>;
export type UserScopesLazyQueryHookResult = ReturnType<typeof useUserScopesLazyQuery>;
export type UserScopesQueryResult = Apollo.QueryResult<UserScopesQuery, UserScopesQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications {
  notifications {
    id
    senderId
    message
    type
    updatedAt
    createdAt
    user {
      profile {
        id
        name
        surname
        fullName
        customSharableString
      }
      account {
        id
      }
    }
    notificationReader {
      state
    }
    status
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const InviteBoardDocument = gql`
    query InviteBoard($input: InviteBoardInput!) {
  inviteBoard(input: $input) {
    name
    id
    status
    editorUser {
      id
      profile {
        fullName
      }
      readMe {
        quickStartComplete
        id
        updatedAt
      }
    }
    boardViewer {
      id
      userId
      boardId
    }
    boardMember {
      id
      userId
      boardId
      user {
        readMe {
          quickStartComplete
          updatedAt
          id
        }
        profile {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useInviteBoardQuery__
 *
 * To run a query within a React component, call `useInviteBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteBoardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteBoardQuery(baseOptions: Apollo.QueryHookOptions<InviteBoardQuery, InviteBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteBoardQuery, InviteBoardQueryVariables>(InviteBoardDocument, options);
      }
export function useInviteBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteBoardQuery, InviteBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteBoardQuery, InviteBoardQueryVariables>(InviteBoardDocument, options);
        }
export type InviteBoardQueryHookResult = ReturnType<typeof useInviteBoardQuery>;
export type InviteBoardLazyQueryHookResult = ReturnType<typeof useInviteBoardLazyQuery>;
export type InviteBoardQueryResult = Apollo.QueryResult<InviteBoardQuery, InviteBoardQueryVariables>;
export const AccountSubscriptionDocument = gql`
    query AccountSubscription {
  accountSubscription {
    plan {
      testStripePriceId
      liveStripePriceId
      plan {
        isActive
        liveStripeProductId
        prices {
          id
          isActive
          liveStripePriceId
          pricePerUnit
          testStripePriceId
        }
        name
        meta
        testStripeProductId
        id
      }
      isActive
      interval
      intervalCount
      id
      pricePerUnit
    }
    seats
    seatsTaken
    billingAction {
      cardLast4digit
      supportEmail
      type
    }
    interval
    activeTo
    activeFrom
    accountId
    invoices {
      description
      invoiceId
      issueDate
      price
      status
      invoiceUrl
    }
    id
    stripeSubscriptionId
    active
    account {
      subscriptions {
        plan {
          testStripePriceId
          liveStripePriceId
          isActive
          id
          pricePerUnit
          plan {
            id
            isActive
            liveStripeProductId
            name
            meta
            testStripeProductId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAccountSubscriptionQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, options);
      }
export function useAccountSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>(AccountSubscriptionDocument, options);
        }
export type AccountSubscriptionQueryHookResult = ReturnType<typeof useAccountSubscriptionQuery>;
export type AccountSubscriptionLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionLazyQuery>;
export type AccountSubscriptionQueryResult = Apollo.QueryResult<AccountSubscriptionQuery, AccountSubscriptionQueryVariables>;